// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:06:22.536Z
// Property: The Wellington (ID: 6767906449166357)
// Collections: 29 amenities, 16 floorplans (live), 30 photos, 76 POIs, 1 reviews, 3 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166357",
  "property_external_id": "30926",
  "property_zillow_url": "https://www.zillow.com/apartments/hatboro-pa/the-wellington/5XjMg8/",
  "property_apartments_url": "https://www.apartments.com/the-wellington-hatboro-pa/12r4qq7/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Wellington+Apartment+Homes/data=!4m2!3m1!1s0x0:0xec865bb9ef34c611?sa=X&ved=2ahUKEwit8MOih7mSAxVwLVkFHUECHfwQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "18278975624",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-wellington",
  "property_name": "The Wellington",
  "property_website_url": "https://www.livethewellingtonapts.com/",
  "property_domain": "https://www.livethewellingtonapts.com/",
  "property_address": "2529 Horsham Road",
  "property_full_address": "2529 Horsham Rd, Hatboro, PA 19040",
  "property_address_1": "2529 Horsham Rd",
  "property_address_2": null,
  "property_address_city": "Hatboro",
  "property_address_state": "PA",
  "property_address_zip_full": "19040",
  "property_address_zip": "19040",
  "property_address_country": "US",
  "property_address_county": "Montgomery County",
  "property_neighborhood_address": "Horsham/Willow Grove",
  "property_address_latitude": "40.1765925",
  "property_address_longitude": "-75.1181292",
  "property_email": "wellington@aionmanagement.com",
  "property_phone": "(215) 443-7300",
  "property_call_tracking_phone": "888-573-8490",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Wellington in Hatboro, PA, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans complete with modern amenities such as a pool, fitness center, and dog park. Find your new home today—browse our availability or schedule a tour to experience community living at its finest!",
  "property_long_description": "Welcome to The Wellington, where modern living meets unmatched comfort in the heart of Hatboro, PA. Our thoughtfully designed apartment community offers a diverse range of floor plans, including one, two, and three-bedroom options to suit your lifestyle. Each residence features upscale finishes such as quartz countertops, stainless steel appliances, and hardwood floors, ensuring you feel right at home.\n\nAt The Wellington, amenities abound to enhance your living experience. Dive into relaxation at our sparkling pool or stay fit in our state-of-the-art fitness center. Enjoy leisurely weekends at our playground, sundeck, or picnic area, complete with grills for outdoor gatherings. For our furry friends, our gated dog park and pet play area provide ample space to roam and play.\n\nConvenience is key at The Wellington, with on-site maintenance and property management ensuring that your needs are met swiftly. Enjoy additional perks like curbside trash pickup, laundry facilities, and storage space. Each apartment is equipped with modern conveniences, including air conditioning, high-speed internet access, and cable readiness.\n\nExplore community features such as a cozy lounge and landscaped courtyard for gatherings or quiet moments. At The Wellington, we prioritize a smoke-free environment to promote a healthy lifestyle.\n\nDiscover your new home today at The Wellington! Browse our availability or schedule a tour to experience the amazing lifestyle that awaits you. Don’t miss the chance to be part of this vibrant community—your new adventure starts here!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd912-cbd3-751c-92d4-6d3083ff1e68.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and subway tile backsplash.",
    "public_id": "019fd912-cbd3-751c-92d4-6d3083ff1e68",
    "storage_key": "property/6767906449166357/019fd912-cbd3-751c-92d4-6d3083ff1e68.webp",
    "width": 1855,
    "height": 1239
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "150",
  "property_year_built": "1964",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.66666666666667",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "700",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Certain dog breeds and mixes (e.g., German Shepherds, Akitas, Rottweilers, Pit Bulls, etc.) are prohibited.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $350 and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://thewellingtonhorsham.loftliving.com/login",
  "property_apply_now_url": "https://www.livethewellingtonapts.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-8137-7333-801c-9d9192eed187.webp",
  "property_primary_logo_media": {
    "alt_text": "The Wellington Apartment Homes logo",
    "public_id": "019d026f-8137-7333-801c-9d9192eed187",
    "storage_key": "property/6767906449166357/019d026f-8137-7333-801c-9d9192eed187.webp",
    "width": 174,
    "height": 84
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-7784-72bd-a6c8-2038aa39ec34.webp",
  "property_secondary_logo_media": {
    "alt_text": "AIon Management logo",
    "public_id": "019d026f-7784-72bd-a6c8-2038aa39ec34",
    "storage_key": "property/6767906449166357/019d026f-7784-72bd-a6c8-2038aa39ec34.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-8d66-70ef-918e-6539298ae044.webp",
  "property_icon_media": {
    "alt_text": "Logo",
    "public_id": "019d026f-8d66-70ef-918e-6539298ae044",
    "storage_key": "property/6767906449166357/019d026f-8d66-70ef-918e-6539298ae044.webp",
    "width": 144,
    "height": 144
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-9a1c-77f4-951a-779013874ae2.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Wellington Apartment Homes logo",
    "public_id": "019d026f-9a1c-77f4-951a-779013874ae2",
    "storage_key": "property/6767906449166357/019d026f-9a1c-77f4-951a-779013874ae2.webp",
    "width": 174,
    "height": 84
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-a2d7-73f8-b3ad-f46e071ffbb9.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Wellington Apartment Homes logo",
    "public_id": "019d026f-a2d7-73f8-b3ad-f46e071ffbb9",
    "storage_key": "property/6767906449166357/019d026f-a2d7-73f8-b3ad-f46e071ffbb9.webp",
    "width": 174,
    "height": 84
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "600 - 1200",
  "property_sqft_min": "600",
  "property_sqft_max": "1200",
  "property_price_range": "1486 - 2459",
  "property_price_min": "1486",
  "property_price_max": "2459",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/thewellingtonhatboro",
  "property_instagram_url": "https://www.instagram.com/thewellingtonapartments",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJRwD-G7ivxokREcY077lbhuw",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Apartments&find_loc=Southampton%2C+PA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Wellington",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to The Wellington in Hatboro, PA, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, and enjoy top-tier amenities like a sparkling pool, fitness center, and dog park. Experience modern living with amazing features, all in a vibrant community designed just for you!",
  "property_home_floorplans_blurb": "Welcome to The Wellington in charming Hatboro, PA—where your ideal home awaits! Choose from our spacious one, two, or three-bedroom floor plans, designed for modern living. Embrace comfort and style by browsing our available apartments and let your new life unfold in this vibrant community.",
  "property_home_gallery_blurb": "At The Wellington in Hatboro, PA, find your ideal sanctuary with our spacious one, two, and three-bedroom floor plans. Enjoy upscale amenities, including a sparkling pool, fitness center, and pet-friendly areas. Picture yourself lounging on the sundeck or grilling in the picnic area—your perfect community awaits!",
  "property_home_neighborhood_blurb": "Welcome to The Wellington, your perfect haven in Hatboro, PA. Nestled amidst lush parks, esteemed schools, and vibrant community hubs, life here promises adventure and convenience. With spacious one, two, and three-bedroom floor plans, you're just moments away from exploring nearby nature reserves, cultural gems, and more. Check it out!",
  "property_home_reviews_blurb": "At The Wellington in Hatboro, PA, our residents rave about our friendly team and supportive atmosphere. One of our satisfied visitors shared, “The ladies there were very approachable as well as informative.” Join a community where you’re valued—see what our residents have to say about living at The Wellington!",
  "property_neighborhood_blurb": "Nestled in the heart of Hatboro, The Wellington offers easy access to parks, schools, and cultural hubs like the Keswick Theatre and Abington Art Center. Enjoy the vibrant community atmosphere, where nature trails and local events bring residents together. Dive into all that surrounds our welcoming apartment community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Wellington in Hatboro, PA, relish upscale living with a range of thoughtfully designed floor plans—choose from one, two, or three bedrooms. Enjoy resort-style amenities, including a sparkling pool, fitness center, and a pet-friendly dog park, all tailored to elevate your lifestyle. Our community promises comfort and convenience, making every day extraordinary.",
  "property_applynow_blurb": "Welcome to The Wellington in Hatboro, PA, where modern living meets comfort! Choose from our spacious one, two, or three-bedroom floor plans, complemented by top-notch amenities like a luxurious pool, fitness center, and pet-friendly areas. Your perfect home awaits—lease online today and elevate your lifestyle!",
  "property_contactus_blurb": "At The Wellington in Hatboro, PA, our thoughtfully designed one, two, and three-bedroom floor plans provide the perfect blend of comfort and style. Embrace a living experience that caters to your lifestyle. Have questions? Contact our leasing team today for personalized assistance and find your ideal home!",
  "property_faqs_blurb": "At The Wellington in Hatboro, PA, you'll find thoughtfully designed one, two, and three-bedroom floor plans tailored for your lifestyle. Curious about community features, amenities, or pet policies? Dive into our FAQs page and uncover the answers you seek about living here in our vibrant apartment community.",
  "property_floorplans_blurb": "At The Wellington in Hatboro, PA, you'll find a variety of thoughtfully designed floor plans to suit every lifestyle. Choose from cozy one-bedroom retreats to spacious three-bedroom havens, all crafted for comfort. Browse our available apartment homes and discover the perfect layout that fits your needs today!",
  "property_gallery_blurb": "Picture yourself living at The Wellington in Hatboro, PA, where comfort meets style. Choose from one, two, or three-bedroom floor plans featuring stainless steel appliances, hardwood floors, and private balconies. Enjoy resort-style amenities like a sparkling pool, fitness center, and dog park—all designed for an enriching lifestyle.",
  "property_interactivemap_blurb": "At The Wellington in Hatboro, PA, your perfect home awaits! Dive into spacious one, two, or three-bedroom apartments equipped with stainless steel appliances and quartz countertops. Embrace a vibrant lifestyle with amenities like a refreshing pool, pet-friendly spaces, and a modern fitness center. Check out our interactive community map to find your new home today!",
  "property_pets_blurb": "At The Wellington in charming Hatboro, PA, your furry friends are embraced! With room for two pets up to 100 lbs, our community caters to your lifestyle—complete with a dedicated pet policy. Live, relax, and enjoy the company of your beloved companions in a vibrant, welcoming atmosphere!",
  "property_referafriend_blurb": "At The Wellington in Hatboro, PA, you’ll find spacious one, two, and three-bedroom apartment floor plans designed for comfort and style. Invite your friends to experience your vibrant community—great friends make great neighbors! Refer a friend today and enjoy life at The Wellington together!",
  "property_residentaccess_blurb": "Welcome to The Wellington, where comfort meets convenience in Hatboro, PA. Our diverse floor plans—spacious one, two, and three-bedroom options—cater to all lifestyles. Access your resident portal now to effortlessly pay rent, schedule maintenance, and enhance your living experience in our vibrant community. Your home awaits!",
  "property_reviews_blurb": "At The Wellington in Hatboro, PA, our friendly team is dedicated to helping you find your perfect home. One resident praised our “approachable and informative” staff, reflecting the welcoming atmosphere we cultivate. Curious about life in our community? See what our residents have to say about their experiences!",
  "property_created_at": "1757012586957",
  "property_scheduletour_blurb": "At The Wellington in Hatboro, PA, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Ready to envision your new home? Schedule a tour today and hear firsthand from our residents about what life is like in our vibrant community!",
  "property_thankyou_blurb": "Thank you for your submission! At The Wellington in Hatboro, PA, we offer stylish one, two, and three-bedroom floor plans designed for your comfort. Our team is excited to connect with you soon and help you find your perfect home in our vibrant community. Stay tuned!",
  "property_virtualtours_blurb": "At The Wellington in Hatboro, PA, diverse floor plans await you—from cozy one-bedrooms to spacious three-bedrooms. Each apartment offers a perfect blend of style and comfort. Don't just imagine your new home; take a virtual tour and see what luxury living looks like today!",
  "property_copyright": "2025 All Rights Reserved. The Wellington",
  "property_seo_title_home": "The Wellington |  Apartments in Hatboro, PA",
  "property_seo_description_home": "Discover modern living at The Wellington in Hatboro, PA. Choose from spacious 1-3 bedroom apartments with excellent amenities and a vibrant community.",
  "property_seo_title_floorplans": "Floor Plans | Hatboro, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The Wellington in Hatboro, PA. Choose from one, two, or three-bedroom layouts. Browse our floor plans and envision your new life!",
  "property_seo_title_amenities": "Amenities | Hatboro, PA Apartments for Rent",
  "property_seo_description_amenities": "Experience stylish living at The Wellington in Hatboro, PA! Enjoy sparkling pools, modern fitness centers, and pet-friendly spaces. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Hatboro, PA",
  "property_seo_description_gallery": "Experience life at The Wellington in Hatboro, PA. Relax by the pool, enjoy modern amenities, and explore your dream home in our photo gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | The Wellington Apartments",
  "property_seo_description_virtualtours": "Experience the charm of The Wellington in Hatboro, PA! Take a virtual tour to discover our inviting one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | The Wellington Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at The Wellington in Hatboro, PA! Browse 1-3 bedroom apartments and enjoy amenities like a pool and pet areas.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Hatboro, PA",
  "property_seo_description_neighborhood": "Explore Hatboro, PA! The Wellington invites you to discover local favorites and hidden gems, all just steps from your home.",
  "property_seo_title_contact": "Contact Us | The Wellington",
  "property_seo_description_contact": "Connect with The Wellington in Hatboro, PA! Our leasing team is ready to assist you with one to three-bedroom floor plans. Let's chat!",
  "property_seo_title_faqs": "FAQs | Apartments in Hatboro, PA",
  "property_seo_description_faqs": "Your questions answered! From floor plans to amenities, our FAQs reveal everything about life at The Wellington in Hatboro, PA. Dive in for details and more!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Hatboro, PA",
  "property_seo_description_reviews": "Experience life at The Wellington in Hatboro, PA. Read resident reviews and discover a vibrant community with top amenities and beautiful floor plans. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Hatboro, PA",
  "property_seo_description_applynow": "Experience modern living at The Wellington in Hatboro, PA! Choose from spacious 1-3 bedroom floor plans and enjoy top-notch amenities. Secure your home today!",
  "property_seo_title_residentaccess": "Resident Access | The Wellington",
  "property_seo_description_residentaccess": "Unlock convenience at The Wellington in Hatboro, PA! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | The Wellington",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Wellington in Hatboro, PA, and enjoy the vibrant lifestyle and community you both deserve.",
  "property_seo_title_scheduletour": "Schedule a Tour | The Wellington",
  "property_seo_description_scheduletour": "Experience vibrant living at The Wellington in Hatboro, PA. Schedule your tour today and find your perfect home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | The Wellington",
  "property_seo_description_privacy": "At The Wellington in Hatboro, PA, your privacy matters. Dive into our privacy policy to understand how we safeguard your personal information securely.",
  "property_seo_title_accessibility": "Website Accessibility | The Wellington",
  "property_seo_description_accessibility": "At The Wellington in Hatboro, PA, we promote digital inclusion with an accessibility statement for a seamless online experience for all.",
  "property_seo_title_sitemap": "Sitemap | The Wellington",
  "property_seo_description_sitemap": "Navigate The Wellington's exceptional amenities and vibrant community in Hatboro, PA. Check out our sitemap to find your ideal apartment today!",
  "property_seo_title_thankyou": "Thank You | The Wellington",
  "property_seo_description_thankyou": "Thank you for your interest in The Wellington! Expect a speedy response from our team as we connect you to your future home in charming Hatboro, PA.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293651510",
  "amenities": [
    {
      "id": "custom_8c97af7f-1b72-4fbf-9785-57061cfc64fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f0c5be0-15dd-44d3-a543-b6e5e9e63261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c56a6eea-c666-4166-988b-aaafee6dc0d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21008245-06f7-4622-b66c-95911163100c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment and Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_512ee135-c4e7-4207-8649-725c364964cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9d1780c-d5c8-4f94-a520-8bcc5da09031",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1ffdd789-7a3d-4e16-bdaa-d4ad2226f164",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6088f4de-efe6-4993-8806-1aad9196c6dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b278c6fc-2acb-4216-b35f-ee465347ac31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d24fb351-37ec-4440-bf9d-b81c263ffdcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_59e8efd6-fbe0-49c7-b8f3-a87ac97c8c83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "In-Unit Washer & Dryers",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_60d0bdb4-21a1-4068-9ad2-fa0246668d20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Over the Range Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ce6d7034-4070-476c-b87b-ab1b0c9e40d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2bdf9beb-7293-45a4-a8f6-741f6a964f10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathroom with Tiled Walls",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0eb46c13-9d09-49c1-bdfb-72bf31b1e057",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_093bd5e3-9955-472f-ba37-a5c50037ff58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5e6f6b6-773e-428c-9c62-db4db197cc3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Subway-Tile Backsplash*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cbf5ef3b-bfe4-4526-aa64-cb2472e1dcf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl-Plank Hardwood Flooring",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c6a3b201-0fe8-4f9b-b13c-c7752fa37234",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Hatboro-Horsham School District",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_495de3ee-d613-426b-8f30-676f3ec9c2ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Less than 10 Minutes to the Shops at Valley Square",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d1d72fa5-62d6-4a9e-b67d-f874baee5b8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Less than 3 Miles to Willow Grove Septa Train Station",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eb6bba3d-637d-4256-bc6f-7cb44c3a060e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Minutes to Shopping, Dining, and Entertainment",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e80e76f-b60f-410b-8fac-7045b5dd4fdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "10 Minutes to Fort Washington",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca08f441-3785-435a-b268-e7380f1b675e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "5 Minutes to PA Turnpike",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0b9a12ed-c3d3-47a9-a36c-529bbcd8f0fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aef897d4-bece-475a-8553-7105ec7b017f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_356b7c35-76bc-4162-8323-ddea83570111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3946967-7e50-4621-b7a7-b88932af7bcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbd66b29-f016-4ea7-bb13-4d307403692d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Units Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_57cb3065-d2a6-4ce0-8e00-903493e6515a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-5d5d-75c0-b41c-2a508c7e311f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019fd931-5d5d-75c0-b41c-2a508c7e311f",
        "storage_key": "property/6767906449166357/019fd931-5d5d-75c0-b41c-2a508c7e311f.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/ee44ba9db5a5d17c5f21eeed4c5f4842-1920w.jpg"
    },
    {
      "id": "custom_2988bd95-ee12-4289-80da-6a9e9ef5a2ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-5d53-709e-83d1-f40b6e6a8027.webp",
      "image_media": {
        "alt_text": "Dining area adjacent to kitchen with a marble-top table and four chairs.",
        "public_id": "019fd931-5d53-709e-83d1-f40b6e6a8027",
        "storage_key": "property/6767906449166357/019fd931-5d53-709e-83d1-f40b6e6a8027.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Enjoy meals in the charming dining area, featuring a stylish marble-top table and comfortable seating, seamlessly connected to the modern kitchen.",
      "link": "",
      "alt_text": "Dining area adjacent to kitchen with a marble-top table and four chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/353933dbeb151c724a73350a3bd0dfa5-1920w.jpg"
    },
    {
      "id": "custom_0e31b158-f2dc-4f3f-a1be-2ba08137ac95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-5d8a-729e-8eb1-d53b52175621.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and dining area.",
        "public_id": "019fd931-5d8a-729e-8eb1-d53b52175621",
        "storage_key": "property/6767906449166357/019fd931-5d8a-729e-8eb1-d53b52175621.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living room in a modern apartment featuring a light gray palette, a sectional sofa, rug, coffee table, and adjacent dining area.",
      "link": "",
      "alt_text": "Living room in a modern apartment with a light gray palette, a sectional sofa, rug, and dining area in the back.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/e0ba5bde25c82a5e0d16d375d931a3c7-1920w.jpg"
    },
    {
      "id": "custom_4ac2e2d0-1e4d-4b5a-806d-79bf753d9763",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-5f6d-727d-afed-4562fa7a65dd.webp",
      "image_media": {
        "alt_text": "Kitchen with black refrigerator, microwave, and oven.",
        "public_id": "019fd931-5f6d-727d-afed-4562fa7a65dd",
        "storage_key": "property/6767906449166357/019fd931-5f6d-727d-afed-4562fa7a65dd.webp",
        "width": 600,
        "height": 450
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring white cabinets, black appliances including a refrigerator, oven, and microwave, with granite countertops.",
      "link": "",
      "alt_text": "Kitchen with black refrigerator, microwave, and oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/Wellington1-1920w.jpg"
    },
    {
      "id": "custom_7cbf025e-fe6b-417c-957c-4dc022e80059",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-6855-728a-ab5a-b7f1864a9021.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and a subway tile backsplash.",
        "public_id": "019fd931-6855-728a-ab5a-b7f1864a9021",
        "storage_key": "property/6767906449166357/019fd931-6855-728a-ab5a-b7f1864a9021.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with stainless steel appliances, white subway tiles, and warm wood cabinets.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, stainless steel appliances, and a white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/358d57aa0b61b7a6ab8f05bec536ff50-1920w.jpg"
    },
    {
      "id": "custom_8185722d-e7f1-49cf-88f1-5c031f98f19a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-686c-759b-aa2c-06296e35acff.webp",
      "image_media": {
        "alt_text": "A bright, modern kitchen and living room with dining table.",
        "public_id": "019fd931-686c-759b-aa2c-06296e35acff",
        "storage_key": "property/6767906449166357/019fd931-686c-759b-aa2c-06296e35acff.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Enjoy the spacious open-concept living and dining area, perfect for entertaining. This apartment features a sleek, modern kitchen with stainless steel appliances and ample cabinet space.",
      "link": "",
      "alt_text": "A bright, modern kitchen and living room with dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/62134f14d1cfcace6bb268c88e36fb51-1920w.jpg"
    },
    {
      "id": "custom_4988cc8a-8ff1-44ca-8969-9b97d2562b22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-6bb2-723d-aecb-651393e0f1b8.webp",
      "image_media": {
        "alt_text": "Living room and dining area in an apartment.",
        "public_id": "019fd931-6bb2-723d-aecb-651393e0f1b8",
        "storage_key": "property/6767906449166357/019fd931-6bb2-723d-aecb-651393e0f1b8.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Living room and dining area in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/2edbd7940ba4868fb3b3efd7bcb72437-1920w.jpg"
    },
    {
      "id": "custom_ce41f38f-67ed-404b-bbed-af4a1053e11e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-6d5c-70bd-ad04-13f6b0c926a8.webp",
      "image_media": {
        "alt_text": "Spacious living room with gray tufted sofa, navy ottoman, armchair, and bookcase.",
        "public_id": "019fd931-6d5c-70bd-ad04-13f6b0c926a8",
        "storage_key": "property/6767906449166357/019fd931-6d5c-70bd-ad04-13f6b0c926a8.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Elegant living room featuring a plush gray sofa, a navy blue storage ottoman, a comfortable armchair, and a rustic wooden bookcase, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Spacious living room with gray tufted sofa, navy ottoman, armchair, and bookcase.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/2877b6e87bee332d8ec0e60d957e7e0c-1920w.jpg"
    },
    {
      "id": "custom_4aa2cdbc-c02d-4e59-b8b5-40ee1d305f32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-734d-7619-8300-169d9458ba8f.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sofa, coffee table, TV, and a framed quote.",
        "public_id": "019fd931-734d-7619-8300-169d9458ba8f",
        "storage_key": "property/6767906449166357/019fd931-734d-7619-8300-169d9458ba8f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Cozy living room in a modern apartment with neutral tones, a white sectional, coffee table, and TV.",
      "link": "",
      "alt_text": "Living room in an apartment with gray walls, a white sectional sofa, coffee table, and wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/98bd93b4164bf6c0481a46df53edddc4-1920w.jpg"
    },
    {
      "id": "custom_16ab4946-fe6c-4497-8c36-327873d4c462",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-748a-70aa-8d69-d2e35c9c8164.webp",
      "image_media": {
        "alt_text": "Dining room with a table set for six and a view of the kitchen.",
        "public_id": "019fd931-748a-70aa-8d69-d2e35c9c8164",
        "storage_key": "property/6767906449166357/019fd931-748a-70aa-8d69-d2e35c9c8164.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment dining space with a wooden table, six chairs, a landscape painting, and a plant near a large window.",
      "link": "",
      "alt_text": "Dining area in an apartment with a wooden table, six chairs, a wall painting, and a plant by the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/0816749b83086f5bc217fc295a41a61e-1920w.jpg"
    },
    {
      "id": "custom_ef4d2f77-ea93-424a-bb73-0d8bc1ae010a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-787c-762b-8ba5-3fa9ac2de62c.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, dresser, closet, and air conditioning unit.",
        "public_id": "019fd931-787c-762b-8ba5-3fa9ac2de62c",
        "storage_key": "property/6767906449166357/019fd931-787c-762b-8ba5-3fa9ac2de62c.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "A bedroom with a queen-size bed, dresser, closet, and air conditioning unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/dd669c3c6d51f56a5936c59dcfcfcead-1920w.jpg"
    },
    {
      "id": "custom_d39cc56b-528b-4c17-8c60-43a5662269d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-79d2-77a5-9b9c-d88e6c94b3e8.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, dresser, and artwork on the wall.",
        "public_id": "019fd931-79d2-77a5-9b9c-d88e6c94b3e8",
        "storage_key": "property/6767906449166357/019fd931-79d2-77a5-9b9c-d88e6c94b3e8.webp",
        "width": 1920,
        "height": 1283
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, a stylish dresser, and elegant artwork to enhance your living space.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, dresser, and artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/6428cdc09f3b278bddc55e2e5acd9306-1920w.jpg"
    },
    {
      "id": "custom_5cb91a03-c777-4420-9e89-0e419bbfdd26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-7e5e-734b-854f-616aadb9c150.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, air conditioning unit, and abstract art on the wall.",
        "public_id": "019fd931-7e5e-734b-854f-616aadb9c150",
        "storage_key": "property/6767906449166357/019fd931-7e5e-734b-854f-616aadb9c150.webp",
        "width": 984,
        "height": 657
      },
      "title": "Apartment",
      "description": "Relax in this cozy bedroom featuring a comfortable queen-size bed, air conditioning, and tasteful abstract wall art. A perfect sanctuary to unwind after a long day.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, air conditioning unit, and abstract art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/d28c9a1f7da584767c3e5c6d18e36182-1920w.jpg"
    },
    {
      "id": "custom_6b0e2588-b83d-4190-8d58-35114524cac4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-8098-712e-9583-5b593690d5d9.webp",
      "image_media": {
        "alt_text": "A bedroom with a queen-size bed, dresser, and full-length mirror.",
        "public_id": "019fd931-8098-712e-9583-5b593690d5d9",
        "storage_key": "property/6767906449166357/019fd931-8098-712e-9583-5b593690d5d9.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Neutral-toned apartment bedroom with a white paneled bed, framed art, blinds, and a window AC unit.",
      "link": "",
      "alt_text": "Bedroom with a white paneled bed, gray walls, blinds, carpet, and a window air conditioner.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/11309be257886f270de04ce60e39f382-1920w.jpg"
    },
    {
      "id": "custom_376aef75-8d08-472b-a831-ca965311df8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-82de-74fc-8b4c-3cb84c97f012.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a king-sized bed, dresser, and laundry closet.",
        "public_id": "019fd931-82de-74fc-8b4c-3cb84c97f012",
        "storage_key": "property/6767906449166357/019fd931-82de-74fc-8b4c-3cb84c97f012.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Neutral-toned apartment bedroom with a wooden dresser, framed wall art, and a relaxed bedding setup.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a bed, dresser, and framed art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/c5926940c1dcd8ae5c5606dc3b3e5961-1920w.jpg"
    },
    {
      "id": "custom_25ea2820-a4c5-41a9-a8d5-57bf0093c682",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-870d-70e9-8c61-5ae316db201a.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, closet, and full-length mirror.",
        "public_id": "019fd931-870d-70e9-8c61-5ae316db201a",
        "storage_key": "property/6767906449166357/019fd931-870d-70e9-8c61-5ae316db201a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Interior bedroom in a multifamily unit with an open closet, wall art, a full-length mirror, and a window air conditioner.",
      "link": "",
      "alt_text": "Bedroom with open closet, framed wall art, a tall wooden full-length mirror, and a window AC.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/d540882b8a0fbe91d2913953f4328a02-1920w.jpg"
    },
    {
      "id": "custom_cec65b6a-1700-4ebc-b37d-5785dbce6d40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-8984-71fc-9e4d-56c7b5d10d7f.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a closet.",
        "public_id": "019fd931-8984-71fc-9e4d-56c7b5d10d7f",
        "storage_key": "property/6767906449166357/019fd931-8984-71fc-9e4d-56c7b5d10d7f.webp",
        "width": 891,
        "height": 1335
      },
      "title": "Apartment",
      "description": "In-unit laundry closet with a stacked washer and dryer for convenient apartment living.",
      "link": "",
      "alt_text": "White stacked washer and dryer in a narrow laundry alcove beside a hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/d7d56b853042d89afc6aa4c5ba5dce84-1920w.jpg"
    },
    {
      "id": "custom_4d03eab9-3696-4e3d-be8f-0e0c3907ab7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-8bcb-74ea-9198-10845f53910e.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower, toilet, and sink.",
        "public_id": "019fd931-8bcb-74ea-9198-10845f53910e",
        "storage_key": "property/6767906449166357/019fd931-8bcb-74ea-9198-10845f53910e.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a shower/tub, gray tile surround, toilet, and sink.",
      "link": "",
      "alt_text": "Bathroom with a shower/tub combo, striped curtain, gray tile surround, toilet and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/f67c86d8e6fd9a71c4ab5beb7935f6ee-1920w.jpg"
    },
    {
      "id": "custom_ea031685-5775-4bf2-ad64-154d0d6a9a8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-9fff-77a1-ba64-3420694f4bbf.webp",
      "image_media": {
        "alt_text": "Dog park with tunnel and agility ramp, surrounded by trees.",
        "public_id": "019fd931-9fff-77a1-ba64-3420694f4bbf",
        "storage_key": "property/6767906449166357/019fd931-9fff-77a1-ba64-3420694f4bbf.webp",
        "width": 1663,
        "height": 1110
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Playground area with a green tunnel, a slide, and seating behind a chain-link fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/e9833ca3/dms3rep/multi/opt/5767906449162442/6767906449166357/7842146f59bb6d27ae9cd64beaa93d01-1920w.jpg"
    },
    {
      "id": "custom_7f0c51c9-49e7-487f-b226-60b4334730da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-b186-7230-92e8-501348fc2282.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas under a blue sky with white clouds.",
        "public_id": "01a1647b-b186-7230-92e8-501348fc2282",
        "storage_key": "property/6767906449166357/01a1647b-b186-7230-92e8-501348fc2282.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas. Enjoy a refreshing dip or soak up the sun in this beautiful community amenity.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas under a blue sky with white clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_40bb0083-be6f-451a-8e91-a5007e54d4ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-aebf-734d-83f8-795cd642f2a0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and orange umbrellas.",
        "public_id": "01a1647b-aebf-734d-83f8-795cd642f2a0",
        "storage_key": "property/6767906449166357/01a1647b-aebf-734d-83f8-795cd642f2a0.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and vibrant orange umbrellas.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and orange umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45e203a9-869e-44fe-8222-6c1ab51e6200",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-a85d-77fa-b541-a22ad457d3ce.webp",
      "image_media": {
        "alt_text": "Exterior of The Wellington Apartments building with leasing office and signage.",
        "public_id": "01a1647b-a85d-77fa-b541-a22ad457d3ce",
        "storage_key": "property/6767906449166357/01a1647b-a85d-77fa-b541-a22ad457d3ce.webp",
        "width": 3072,
        "height": 2039
      },
      "title": "Community",
      "description": "Welcome to The Wellington Apartments, featuring a well-maintained brick exterior with lush landscaping and a visible leasing office entrance.",
      "link": "",
      "alt_text": "Exterior of The Wellington Apartments building with leasing office and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c58673a4-ba60-4285-a258-ea7df3b1da23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-a67e-7631-b52d-29013b4cc028.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with manicured lawns and a street in front.",
        "public_id": "01a1647b-a67e-7631-b52d-29013b4cc028",
        "storage_key": "property/6767906449166357/01a1647b-a67e-7631-b52d-29013b4cc028.webp",
        "width": 3072,
        "height": 2039
      },
      "title": "Community",
      "description": "Welcome to Wellington Apartments, offering a charming community setting with well-maintained brick buildings, lush green spaces, and convenient leasing office access.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with manicured lawns and a street in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_446d4cfc-089f-49da-82d7-7efce06d98c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-768f-74d4-86d7-554fa5bce9b7.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with shutters and manicured bushes.",
        "public_id": "01a1647b-768f-74d4-86d7-554fa5bce9b7",
        "storage_key": "property/6767906449166357/01a1647b-768f-74d4-86d7-554fa5bce9b7.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Charming brick apartment building exterior with well-maintained landscaping and shutters.",
      "link": "",
      "alt_text": "Exterior of a brick apartment building with shutters and manicured bushes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_738af29c-121e-461c-abd8-cead0f3171d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-8cdc-7151-a894-3b15c6987333.webp",
      "image_media": {
        "alt_text": "Covered picnic area with grills and seating",
        "public_id": "01a1647b-8cdc-7151-a894-3b15c6987333",
        "storage_key": "property/6767906449166357/01a1647b-8cdc-7151-a894-3b15c6987333.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings in our covered picnic area, complete with grills and ample seating for residents.",
      "link": "",
      "alt_text": "Covered picnic area with grills and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_001ff465-faa8-4837-b6b4-8473355c4a3c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-8a9f-72fa-88f1-a5334521fdcb.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with manicured lawns and trees.",
        "public_id": "01a1647b-8a9f-72fa-88f1-a5334521fdcb",
        "storage_key": "property/6767906449166357/01a1647b-8a9f-72fa-88f1-a5334521fdcb.webp",
        "width": 3072,
        "height": 2038
      },
      "title": "Community",
      "description": "Charming brick building with well-maintained landscaping. Offers a welcoming entrance and comfortable living spaces.",
      "link": "",
      "alt_text": "Exterior of a brick apartment building with manicured lawns and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78fcc9da-d88c-42d4-8ceb-9aa233b8a224",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-7c6e-74de-b9dd-666a487ed731.webp",
      "image_media": {
        "alt_text": "Monument sign for The Wellington Apartments with address 2529.",
        "public_id": "01a1647b-7c6e-74de-b9dd-666a487ed731",
        "storage_key": "property/6767906449166357/01a1647b-7c6e-74de-b9dd-666a487ed731.webp",
        "width": 3072,
        "height": 2039
      },
      "title": "Community",
      "description": "Welcome to The Wellington Apartments, located at 2529. Contact us at 215.443.7300 or visit livethewellingtonapts.com.",
      "link": "",
      "alt_text": "Monument sign for The Wellington Apartments with address 2529.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9b34934-5841-4f86-b162-1a92d2995021",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-7ba7-75e0-8421-bf4a5d71dae9.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and free weights.",
        "public_id": "01a1647b-7ba7-75e0-8421-bf4a5d71dae9",
        "storage_key": "property/6767906449166357/01a1647b-7ba7-75e0-8421-bf4a5d71dae9.webp",
        "width": 3072,
        "height": 2039
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, elliptical machines, and a full range of free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8371a3ca-4adc-4c6b-ac59-27dc7166bf01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-7a1a-732c-a1eb-f2434688332c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with wood cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "01a1647b-7a1a-732c-a1eb-f2434688332c",
        "storage_key": "property/6767906449166357/01a1647b-7a1a-732c-a1eb-f2434688332c.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Apartment",
      "description": "Experience culinary comfort in this beautifully appointed kitchen, featuring sleek stainless steel appliances, ample wood cabinetry, and a clean subway tile backsplash.",
      "link": "",
      "alt_text": "Modern kitchen with wood cabinets, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_994826db-d8b9-463d-8fa9-0fe73a84e0b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-7aa0-77db-bfb8-716634d1c595.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines",
        "public_id": "01a1647b-7aa0-77db-bfb8-716634d1c595",
        "storage_key": "property/6767906449166357/01a1647b-7aa0-77db-bfb8-716634d1c595.webp",
        "width": 3072,
        "height": 2039
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a5295620-edcd-400a-9b05-fe3ad645bbb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Jones'n Bagels",
      "poi_type": "Restaurants",
      "poi_address": "315 N York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Breakfast and lunch spot offering bagel sandwiches, plus coffee, cold brew and vegan options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-5ae5-760c-9159-ddf75fc2446c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-5ae5-760c-9159-ddf75fc2446c",
        "storage_key": "property/6767906449166357/019d026d-5ae5-760c-9159-ddf75fc2446c.webp",
        "width": 1079,
        "height": 641
      },
      "poi_business_url": "http://jonesnbagels.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11535497148130222289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jonesn-bagels",
      "poi_latitude": "40.1816627",
      "poi_longitude": "-75.10541549999999",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-282-8511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1WlsHDevxokR0WDV3YlRFqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_0cd7be95-6f74-4400-a168-49ddedb2460c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Lochel's Bakery",
      "poi_type": "Restaurants",
      "poi_address": "57 S York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Bakery focusing on special-occasion cakes also offers cupcakes, cookies, pies & pastries.",
      "poi_long_description": "Bakery focusing on special-occasion cakes also offers cupcakes, cookies, pies & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-5ae4-739d-b0f6-33d4466eca7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-5ae4-739d-b0f6-33d4466eca7c",
        "storage_key": "property/6767906449166357/019d026d-5ae4-739d-b0f6-33d4466eca7c.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://www.lochelsbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2483776753159278624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lochels-bakery",
      "poi_latitude": "40.17573700000001",
      "poi_longitude": "-75.10627699999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-773-9779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ89g1FkuuxokRIJBuIcwleCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_dc5ea9d5-e68b-40e7-a4b3-9c6c0d2e486d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "LUHV Factory & Vegan Bistro",
      "poi_type": "Restaurants",
      "poi_address": "101 N York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Casual vegan eatery for soups, burgers and sandwiches including grilled cheese and Rueben.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-5ae4-739d-b0f6-2ffd377c1a89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-5ae4-739d-b0f6-2ffd377c1a89",
        "storage_key": "property/6767906449166357/019d026d-5ae4-739d-b0f6-2ffd377c1a89.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.luhvfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=67350981193726924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luhv-factory--vegan-bistro",
      "poi_latitude": "40.1794449",
      "poi_longitude": "-75.1058558",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-444-9002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZ5W5EyuxokRzHtTTVxH7wA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vegan_restaurant"
    },
    {
      "id": "custom_b03bd89d-5b06-406a-96ea-2cb17a897472",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Greek Korner",
      "poi_type": "Restaurants",
      "poi_address": "133 S York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Greek eatery featuring lamb gyros, chicken souvlaki and moussaka.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-5afd-7245-b38d-4ff6b8a47731.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-5afd-7245-b38d-4ff6b8a47731",
        "storage_key": "property/6767906449166357/019d026d-5afd-7245-b38d-4ff6b8a47731.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://greekkorner.toast.site/order",
      "poi_directions_map_url": "https://maps.google.com/?cid=14644210853728702873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greek-korner",
      "poi_latitude": "40.1747503",
      "poi_longitude": "-75.1065332",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 445-265-5569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7gVSdevxokRmVFr4C6wOss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_77a8c12e-d7f2-4545-8306-16a23cf4da4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "PrimoHoagies",
      "poi_type": "Restaurants",
      "poi_address": "313 N York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Philly-born counter-serve sandwich chain known for its hefty hoagies built on sesame-seed rolls.",
      "poi_long_description": "Philly-born counter-serve sandwich chain known for its hefty hoagies built on sesame-seed rolls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-5f82-749b-a492-c5dc270dd5e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-5f82-749b-a492-c5dc270dd5e6",
        "storage_key": "property/6767906449166357/019d026d-5f82-749b-a492-c5dc270dd5e6.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.primohoagies.com/location/Hatboro-PA",
      "poi_directions_map_url": "https://maps.google.com/?cid=6292736655324302877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primohoagies",
      "poi_latitude": "40.1816106",
      "poi_longitude": "-75.1054523",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-957-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJydcdflKuxokRHU6vzaVKVFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_69132203-c835-4b17-a355-0833c38a8e0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Joe's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "39 S York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Classic & inside-out pizzas, traditional Italian eats & Philly-style sandwiches in simple surrounds.",
      "poi_long_description": "Classic & inside-out pizzas, traditional Italian eats & Philly-style sandwiches in simple surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-602b-73d5-b852-40184de72093.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-602b-73d5-b852-40184de72093",
        "storage_key": "property/6767906449166357/019d026d-602b-73d5-b852-40184de72093.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://joespizzahatboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14477056797598263564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joes-pizza",
      "poi_latitude": "40.17621200000001",
      "poi_longitude": "-75.106233",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-675-1687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ZKUP0uuxokRDKn_ZXTW6Mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_c58862df-3cd4-457c-a526-ba707ef94aa1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Towey's Hatboro Tavern",
      "poi_type": "Restaurants",
      "poi_address": "117 S York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Lively neighborhood bar with karaoke, trivia nights, and bar food such as wings and cheesesteaks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-60af-724e-acd1-64d4e0211d2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-60af-724e-acd1-64d4e0211d2f",
        "storage_key": "property/6767906449166357/019d026d-60af-724e-acd1-64d4e0211d2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://toweystavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10117223658934941117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toweys-hatboro-tavern",
      "poi_latitude": "40.1751249",
      "poi_longitude": "-75.1064847",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-344-8023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d6-7568-8649-6acd42b89341.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d6-7568-8649-6acd42b89341",
        "storage_key": "property/6767906449166357/019d026d-c6d6-7568-8649-6acd42b89341.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrfzSIUuuxokRvbX-f1CZZ4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_a3a98656-1fde-41e2-8036-c05cb61b276b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Ming's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "121 S York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "BYOB Asian bistro with a well-lit dining room & a menu of classic Chinese dishes & Korean noodles.",
      "poi_long_description": "BYOB Asian bistro with a well-lit dining room & a menu of classic Chinese dishes & Korean noodles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-60ae-779a-ac71-5d77a95fe0ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-60ae-779a-ac71-5d77a95fe0ec",
        "storage_key": "property/6767906449166357/019d026d-60ae-779a-ac71-5d77a95fe0ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mings-restaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13026522279139838797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mings-restaurant",
      "poi_latitude": "40.174985",
      "poi_longitude": "-75.1065332",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-674-8804",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpa7KIEuuxokRTYvX0v6Ax7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_115d51c9-da8f-4dea-9952-7518e71b5d17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Manja Pizzeria & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "332 S York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18221824697518707224&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "manja-pizzeria--restaurant",
      "poi_latitude": "40.1725328",
      "poi_longitude": "-75.1094315",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI42wnsqvxokRGNIK3wTt4Pw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2c555d3e-e6a2-417a-a7a4-0a5f5b0c9a5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Hatboro Pizza-Grill",
      "poi_type": "Restaurants",
      "poi_address": "213 N York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Quaint family-run pizzeria serves traditional & white pizzas plus sandwiches & burgers.",
      "poi_long_description": "Quaint family-run pizzeria serves traditional & white pizzas plus sandwiches & burgers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-64a4-7628-9705-c2d37fcdd659.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-64a4-7628-9705-c2d37fcdd659",
        "storage_key": "property/6767906449166357/019d026d-64a4-7628-9705-c2d37fcdd659.webp",
        "width": 1032,
        "height": 1032
      },
      "poi_business_url": "http://hatboropizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16688447533738750198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatboro-pizza-grill",
      "poi_latitude": "40.180719",
      "poi_longitude": "-75.105553",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-442-7824",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9VWQDk2uxokR9vA93ZxGmec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_739d14c9-fb85-4844-8f93-8ac9c0181f26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "The Pizza Pasta House",
      "poi_type": "Restaurants",
      "poi_address": "104 W Moreland Ave, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6080158491168158385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pizza-pasta-house",
      "poi_latitude": "40.178932",
      "poi_longitude": "-75.10887699999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-674-3233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZM5R7OvxokRsTInBO8PYVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_delivery"
    },
    {
      "id": "custom_f3ed0965-35d8-4f15-8b84-187550ac2661",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "339 W County Line Rd",
      "poi_type": "Restaurants",
      "poi_address": "339 W County Line Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?q=339+W+County+Line+Rd,+Hatboro,+PA+19040,+USA&ftid=0x89c6af0f169922fb:0xd344ddb85c9e3ebe&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "339-w-county-line-rd",
      "poi_latitude": "40.2004119",
      "poi_longitude": "-75.1212755",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "EiwzMzkgVyBDb3VudHkgTGluZSBSZCwgSGF0Ym9ybywgUEEgMTkwNDAsIFVTQSIxEi8KFAoSCfsimRYPr8aJEVTattx2Da0JENMCKhQKEgn9feEUD6_GiREStXpocrNTFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8a6b451f-de23-4d5c-913a-eb683630211f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "GIANT",
      "poi_type": "Shopping & Retail",
      "poi_address": "315 N York Rd, Willow Grove, PA 19090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-6538-7342-91c1-158ef86d5e8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-6538-7342-91c1-158ef86d5e8e",
        "storage_key": "property/6767906449166357/019d026d-6538-7342-91c1-158ef86d5e8e.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://stores.giantfoodstores.com/pa/willow-grove/315-york-rd?y_source=1_NDE5NTU4NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=458589246372006403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant",
      "poi_latitude": "40.1466917",
      "poi_longitude": "-75.11480209999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-784-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6da-73dd-abb6-63fc67b41832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6da-73dd-abb6-63fc67b41832",
        "storage_key": "property/6767906449166357/019d026d-c6da-73dd-abb6-63fc67b41832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe4rCly6wxokRA0rRZ308XQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f38c3c6f-53c1-47ee-980a-ae0e639fc778",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "ACME Markets",
      "poi_type": "Shopping & Retail",
      "poi_address": "200 Blair Mill Rd, Horsham, PA 19044, USA",
      "poi_short_description": "Chain grocery outpost offering meat, fish, produce, and deli items, plus a bakery and a florist.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-655c-70af-b437-234ddd60d017.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-655c-70af-b437-234ddd60d017",
        "storage_key": "property/6767906449166357/019d026d-655c-70af-b437-234ddd60d017.webp",
        "width": 1088,
        "height": 612
      },
      "poi_business_url": "https://local.acmemarkets.com/pa/horsham/200-blair-mill-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12332177715500875286&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acme-markets",
      "poi_latitude": "40.1838996",
      "poi_longitude": "-75.1181361",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-956-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6da-73dd-abb6-63fc67b41832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6da-73dd-abb6-63fc67b41832",
        "storage_key": "property/6767906449166357/019d026d-c6da-73dd-abb6-63fc67b41832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRpczrGvxokRFv5qJ0uyJKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_64537097-dd3c-4296-8e5b-1cc4e81e5bbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "765 E County Line Rd, Warminster, PA 18974, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-6636-717d-82e2-83058b5763db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-6636-717d-82e2-83058b5763db",
        "storage_key": "property/6767906449166357/019d026d-6636-717d-82e2-83058b5763db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/hatboro-pa-pharmacies/765-east-county-line-rd-hatboro-pa-19040/storeid=4662?WT.mc_id=LS_GOOGLE_FS_4662",
      "poi_directions_map_url": "https://maps.google.com/?cid=18279544981431649356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.1725627",
      "poi_longitude": "-75.07246169999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-322-2443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMS1aoluuxokRTAQCuk_9rf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_cc99f07b-e483-43db-b1a3-a2f82eacb289",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "412 S York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-6a5b-76bc-91df-0cc6fa09c5de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-6a5b-76bc-91df-0cc6fa09c5de",
        "storage_key": "property/6767906449166357/019d026d-6a5b-76bc-91df-0cc6fa09c5de.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.wawa.com/locations/8122?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=11877483782971241609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "40.1714572",
      "poi_longitude": "-75.11056409999999",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 267-297-4476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6d5-712b-abd2-39ad32bb823b",
        "storage_key": "property/6767906449166357/019d026d-c6d5-712b-abd2-39ad32bb823b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgt9MqvxokRibR2LZJM1aQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_779a4043-5ef6-4cd6-ab3d-72037aa1b0e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "317 W County Line Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-6af4-73a5-8175-83d6edc0a3b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-6af4-73a5-8175-83d6edc0a3b4",
        "storage_key": "property/6767906449166357/019d026d-6af4-73a5-8175-83d6edc0a3b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/pa/hatboro/317-w-county-line-rd-11399?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16117473317169057139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.1990092",
      "poi_longitude": "-75.1190113",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-674-5299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ca0c-74de-a849-9c1cfddf43bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ca0c-74de-a849-9c1cfddf43bf",
        "storage_key": "property/6767906449166357/019d026d-ca0c-74de-a849-9c1cfddf43bf.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJyeh0BwavxokRc82ygpbErN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_1bff7ebc-3df2-44e0-ad9a-d6686bff84a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Ollie's Bargain Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "200 Blair Mill Rd, Horsham, PA 19044, USA",
      "poi_short_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_long_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-6ae7-71a7-b96e-9fd9a39527da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-6ae7-71a7-b96e-9fd9a39527da",
        "storage_key": "property/6767906449166357/019d026d-6ae7-71a7-b96e-9fd9a39527da.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.ollies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5612128340702907335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ollies-bargain-outlet",
      "poi_latitude": "40.182964",
      "poi_longitude": "-75.1194165",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-674-2740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ca80-73b9-b1e6-82c1aee98311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ca80-73b9-b1e6-82c1aee98311",
        "storage_key": "property/6767906449166357/019d026d-ca80-73b9-b1e6-82c1aee98311.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3YmvorCvxokRx8t_1f1I4k0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_670dd0a5-8c58-4a1b-9229-c6c6a4d69afb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "200 Blair Mill Rd #5, Horsham, PA 19044, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-6ab8-776e-a2b0-faeaf306c39f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-6ab8-776e-a2b0-faeaf306c39f",
        "storage_key": "property/6767906449166357/019d026d-6ab8-776e-a2b0-faeaf306c39f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/pa/horsham/200-blair-mill-road-suit-5?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8998693786334289327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "40.1830113",
      "poi_longitude": "-75.11912029999999",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 267-317-7376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ca80-73b9-b1e6-82c1aee98311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ca80-73b9-b1e6-82c1aee98311",
        "storage_key": "property/6767906449166357/019d026d-ca80-73b9-b1e6-82c1aee98311.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc3GlorCvxokRr134UFLI4Xw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_90cb40cc-d244-472d-b4cd-9e0346b40597",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Willow Grove Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 W Moreland Rd, Willow Grove, PA 19090, USA",
      "poi_short_description": "More than 130 retailers in a 3-story shopping mall with Victorian-era inspired decor & a carousel.",
      "poi_long_description": "More than 130 retailers in a 3-story shopping mall with Victorian-era inspired decor & a carousel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-6ee3-738d-9306-0c2d9e648d7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-6ee3-738d-9306-0c2d9e648d7d",
        "storage_key": "property/6767906449166357/019d026d-6ee3-738d-9306-0c2d9e648d7d.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://willowgroveparkmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7320160412435769219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-grove-park",
      "poi_latitude": "40.1401974",
      "poi_longitude": "-75.1236988",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-657-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ca80-73b9-b1e6-82c1aee98311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ca80-73b9-b1e6-82c1aee98311",
        "storage_key": "property/6767906449166357/019d026d-ca80-73b9-b1e6-82c1aee98311.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfxx3xTuwxokRg2ccehxvlmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5da4b3a7-69c8-49ef-b053-ea199fe6db1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "114 Park Ave Spc Ste 4, Willow Grove, PA 19090, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-7025-72a6-8bfe-dacf1ecce5e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-7025-72a6-8bfe-dacf1ecce5e2",
        "storage_key": "property/6767906449166357/019d026d-7025-72a6-8bfe-dacf1ecce5e2.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=702889633916348384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "40.1425317",
      "poi_longitude": "-75.1168185",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 267-794-9770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ca80-73b9-b1e6-82c1aee98311.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ca80-73b9-b1e6-82c1aee98311",
        "storage_key": "property/6767906449166357/019d026d-ca80-73b9-b1e6-82c1aee98311.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyRtn2S-wxokR4Gfj4WUqwQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_92c600fe-65ec-4cec-928b-048489db0bf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Amazon Fresh",
      "poi_type": "Shopping & Retail",
      "poi_address": "102 Park Ave, Willow Grove, PA 19090, USA",
      "poi_short_description": "Clean Amazon-owned supermarket selling fresh produce and packaged foods, as well as ready-to-eat meals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-70e9-7238-8fcd-c50468e6ca1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-70e9-7238-8fcd-c50468e6ca1a",
        "storage_key": "property/6767906449166357/019d026d-70e9-7238-8fcd-c50468e6ca1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://amzn.to/3cE3z9X",
      "poi_directions_map_url": "https://maps.google.com/?cid=17566201207011088046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-fresh",
      "poi_latitude": "40.1419671",
      "poi_longitude": "-75.1172484",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-250-0668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6da-73dd-abb6-63fc67b41832.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6da-73dd-abb6-63fc67b41832",
        "storage_key": "property/6767906449166357/019d026d-c6da-73dd-abb6-63fc67b41832.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwXKZvFaxxokRrhbvlO2ux_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5e1b8ec5-55ed-4064-aa99-55d741c61e70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Crooked Billet Elementary School",
      "poi_type": "Education",
      "poi_address": "101 Meadowbrook Ave, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-70e9-7238-8fcd-c9d993ab9f37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-70e9-7238-8fcd-c9d993ab9f37",
        "storage_key": "property/6767906449166357/019d026d-70e9-7238-8fcd-c9d993ab9f37.webp",
        "width": 999,
        "height": 581
      },
      "poi_business_url": "https://www.hatboro-horsham.org/o/cbes",
      "poi_directions_map_url": "https://maps.google.com/?cid=10604768363745489625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crooked-billet-elementary-school",
      "poi_latitude": "40.1843222",
      "poi_longitude": "-75.0997656",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-420-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY_pxn1GuxokR2bJZ7qO0K5M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8d02a6a6-0398-415f-9fde-9c211f847196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Blair Mill Elementary",
      "poi_type": "Education",
      "poi_address": "109 Bender Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hatboro-horsham.org/o/bmes",
      "poi_directions_map_url": "https://maps.google.com/?cid=16162800114003608088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blair-mill-elementary",
      "poi_latitude": "40.1882161",
      "poi_longitude": "-75.1139458",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-420-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDXiqaPevxokRGALUyhHNTeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_cfc33865-52ca-4e2a-849b-516a83ba69b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Keith Valley Middle School",
      "poi_type": "Education",
      "poi_address": "227 Meetinghouse Rd, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hatboro-horsham.org/o/kvms",
      "poi_directions_map_url": "https://maps.google.com/?cid=14318956642121761867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keith-valley-middle-school",
      "poi_latitude": "40.1857745",
      "poi_longitude": "-75.12635259999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-420-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuXHcN6OvxokRS0TjbzMnt8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6624a213-2868-44d1-aa40-81397075ae15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Hatboro-Horsham Senior High School",
      "poi_type": "Education",
      "poi_address": "899 Horsham Rd, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-74c1-758a-b1d8-afc43d48d5fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-74c1-758a-b1d8-afc43d48d5fb",
        "storage_key": "property/6767906449166357/019d026d-74c1-758a-b1d8-afc43d48d5fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hatboro-horsham.org/o/hhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=13808724274696529828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatboro-horsham-senior-high-school",
      "poi_latitude": "40.1977382",
      "poi_longitude": "-75.16351689999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-420-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOYzf8XilxokRpKeZ6pBxor8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_49b14bd1-7b53-4472-a742-145bea946cee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Simmons Elementary School",
      "poi_type": "Education",
      "poi_address": "411 Babylon Rd, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hatboro-horsham.org/o/ses/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10574089688096787561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "simmons-elementary-school",
      "poi_latitude": "40.19880730000001",
      "poi_longitude": "-75.1704141",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-420-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiWZHqnelxokRaUwhIoy2vpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ecb3dedb-9e6f-4558-98c3-21adc95edfd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Hallowell Elementary School",
      "poi_type": "Education",
      "poi_address": "501 W Moreland Ave, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.hatboro-horsham.org/o/hes",
      "poi_directions_map_url": "https://maps.google.com/?cid=16257636356611774562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hallowell-elementary-school",
      "poi_latitude": "40.1943793",
      "poi_longitude": "-75.136117",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-420-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPQnMGgCvxokRYhhSMyG6nuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e013e9ea-be4d-46aa-a423-c360251039d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Hatboro KinderCare",
      "poi_type": "Education",
      "poi_address": "378 S Warminster Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-760c-77bd-a1a2-62f699639ef2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-760c-77bd-a1a2-62f699639ef2",
        "storage_key": "property/6767906449166357/019d026d-760c-77bd-a1a2-62f699639ef2.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/hatboro/pa/303810?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA4MjI1LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=13760349398568730483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatboro-kindercare",
      "poi_latitude": "40.1716639",
      "poi_longitude": "-75.10183649999999",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-957-9640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4W7YOjSuxokRc__yXt-U9r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_b3d70b1b-258f-4ed4-ba7e-0ab3bd6b8b66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Lehman Christian Preschool",
      "poi_type": "Education",
      "poi_address": "300 S York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.lehmanchristianpreschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1616176695558790628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehman-christian-preschool",
      "poi_latitude": "40.1730539",
      "poi_longitude": "-75.10848179999999",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-675-5020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC8boU7WvxokR5N0LSSTQbRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_d9915c6c-0985-4f81-a948-5137de25bd3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Willow Dale Elementary School PA",
      "poi_type": "Education",
      "poi_address": "720 N Norristown Rd, Warminster, PA 18974, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-76ad-7232-9c31-7bf0253d9348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-76ad-7232-9c31-7bf0253d9348",
        "storage_key": "property/6767906449166357/019d026d-76ad-7232-9c31-7bf0253d9348.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wdes.centennialsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11562923402169412117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-dale-elementary-school-pa",
      "poi_latitude": "40.2143021",
      "poi_longitude": "-75.1056196",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-441-6093",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu7FbSt6uxokRFepbP5LBd6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e1688d35-1082-48bc-a1aa-94566e6e5fd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Chesterbrook Academy Preschool",
      "poi_type": "Education",
      "poi_address": "116 Welsh Rd unit h, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-76ef-72a9-b35e-fdf63f35daa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-76ef-72a9-b35e-fdf63f35daa3",
        "storage_key": "property/6767906449166357/019d026d-76ef-72a9-b35e-fdf63f35daa3.webp",
        "width": 1280,
        "height": 770
      },
      "poi_business_url": "https://www.chesterbrookacademy.com/preschools/pa/montgomery-county/horsham/?utm_medium=directory&utm_source=gmb&utm_campaign=profile&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=11537708701453015512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chesterbrook-academy-preschool",
      "poi_latitude": "40.159931",
      "poi_longitude": "-75.1449986",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-607-2398",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2ykLeiavxokR2FkKQO8sHqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_4426ea8d-dd8f-44e9-8d67-00f8878b11db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Keswick Theatre",
      "poi_type": "Entertainment",
      "poi_address": "291 N Keswick Ave, Glenside, PA 19038, USA",
      "poi_short_description": "Built in 1928 as a vaudeville/movie theater, this 1,300-seat space now hosts diverse music acts.",
      "poi_long_description": "Built in 1928 as a vaudeville/movie theater, this 1,300-seat space now hosts diverse music acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-7b9d-73b0-ad04-c5ea1587625a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-7b9d-73b0-ad04-c5ea1587625a",
        "storage_key": "property/6767906449166357/019d026d-7b9d-73b0-ad04-c5ea1587625a.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.keswicktheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15835453283059281234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keswick-theatre",
      "poi_latitude": "40.1063448",
      "poi_longitude": "-75.14718959999999",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 215-572-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aLkPZuwxokRUq0KctzUwts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_08bea734-632a-4078-bf9e-e5471938e753",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Tilted 10",
      "poi_type": "Entertainment",
      "poi_address": "2500 W Moreland Rd, Willow Grove, PA 19090, USA",
      "poi_short_description": "Sprawling entertainment center featuring bowling, mini golf, laser tag, arcade games and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-7bb8-720e-a48e-6c14dd26259f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-7bb8-720e-a48e-6c14dd26259f",
        "storage_key": "property/6767906449166357/019d026d-7bb8-720e-a48e-6c14dd26259f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://tilted10.com/willow-grove/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18390809058095637694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tilted-10",
      "poi_latitude": "40.14053610000001",
      "poi_longitude": "-75.1254986",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 267-715-5552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YiXszuxxokRvqTTT2ZHOf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_7ca4e0e1-008c-4428-b012-166b7d973534",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Abington Art Center",
      "poi_type": "Entertainment",
      "poi_address": "515 Meetinghouse Rd, Jenkintown, PA 19046, USA",
      "poi_short_description": "Sculpture gardens and walking trails feature at this art center with events, classes, and a treehouse.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-7d0e-73e8-80dc-a12e18852c7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-7d0e-73e8-80dc-a12e18852c7b",
        "storage_key": "property/6767906449166357/019d026d-7d0e-73e8-80dc-a12e18852c7b.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "http://abingtonartcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17812701015340068863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abington-art-center",
      "poi_latitude": "40.09222889999999",
      "poi_longitude": "-75.117054",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 215-887-4882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VPybt2wxokR_6-VnTJtM_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "custom_b015744a-dd77-404e-86a4-d32c3c45dc86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Lorimer Park",
      "poi_type": "Entertainment",
      "poi_address": "183 Moredon Rd, Huntingdon Valley, PA 19006, USA",
      "poi_short_description": "Meadows, woods & a scenic creek attract horseback riders, birders, hikers & other nature lovers.",
      "poi_long_description": "Meadows, woods & a scenic creek attract horseback riders, birders, hikers & other nature lovers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-7dba-77ba-9b88-ebd92090a5c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-7dba-77ba-9b88-ebd92090a5c6",
        "storage_key": "property/6767906449166357/019d026d-7dba-77ba-9b88-ebd92090a5c6.webp",
        "width": 1095,
        "height": 1280
      },
      "poi_business_url": "https://www.montcopa.org/872/Lorimer-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=354651384762853688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lorimer-park",
      "poi_latitude": "40.0969929",
      "poi_longitude": "-75.0736507",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 215-947-3477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4_tSHCxxokROOnjL4756wQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3a98a048-7a91-4705-96c1-0804d3cb0736",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Ardmore Music Hall",
      "poi_type": "Entertainment",
      "poi_address": "23 E Lancaster Ave, Ardmore, PA 19003, USA",
      "poi_short_description": "Intimate venue featuring touring bands, cover acts and a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-8320-72fd-86a6-83b1f36523ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-8320-72fd-86a6-83b1f36523ae",
        "storage_key": "property/6767906449166357/019d026d-8320-72fd-86a6-83b1f36523ae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ardmoremusichall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15998919079455507049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ardmore-music-hall",
      "poi_latitude": "40.007598",
      "poi_longitude": "-75.289963",
      "poi_miles_from_property": "18",
      "poi_walking_minutes": "6 hours 55 mins",
      "poi_biking_minutes": "2 hours 2 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 610-649-8389",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVxRaIbAxokRaUIqCSOUB94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "custom_7ea7dda0-12cb-4df1-8e53-a0da6876af74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Hiway Theater",
      "poi_type": "Entertainment",
      "poi_address": "212 York Rd, Jenkintown, PA 19046, USA",
      "poi_short_description": "This single-screen cinema built in 1913 focuses on independent, art-house & foreign films.",
      "poi_long_description": "This single-screen cinema built in 1913 focuses on independent, art-house & foreign films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-83ed-718a-92b0-4f333aa396e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-83ed-718a-92b0-4f333aa396e4",
        "storage_key": "property/6767906449166357/019d026d-83ed-718a-92b0-4f333aa396e4.webp",
        "width": 914,
        "height": 1280
      },
      "poi_business_url": "http://www.hiwaytheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12685701504232848994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hiway-theater",
      "poi_latitude": "40.0947767",
      "poi_longitude": "-75.1254988",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 267-864-0065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ce35-7701-8f56-4956673ae208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ce35-7701-8f56-4956673ae208",
        "storage_key": "property/6767906449166357/019d026d-ce35-7701-8f56-4956673ae208.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJWRaW_8GwxokRYv5vbk6qDLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6058e211-7140-4583-981a-640d8f37fef9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "PHS Meadowbrook Farm",
      "poi_type": "Entertainment",
      "poi_address": "1633 Washington Ln, Meadowbrook, PA 19046, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-87a7-734f-9a35-ac161f75fed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-87a7-734f-9a35-ac161f75fed9",
        "storage_key": "property/6767906449166357/019d026d-87a7-734f-9a35-ac161f75fed9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://phsonline.org/locations/phs-meadowbrook-farm",
      "poi_directions_map_url": "https://maps.google.com/?cid=10839582224461760928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phs-meadowbrook-farm",
      "poi_latitude": "40.1183215",
      "poi_longitude": "-75.0956212",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 215-887-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJx5dxk6WxxokRoImuQprubZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_28c013ae-12f0-49ee-b1b7-5785a85839eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Briar Bush Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "1212 Edge Hill Rd, Abington, PA 19001, USA",
      "poi_short_description": "Educational wildlife center featuring a playground, plus live animal exhibits and outdoor trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-87f6-763d-a4d8-9f979bbd856c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-87f6-763d-a4d8-9f979bbd856c",
        "storage_key": "property/6767906449166357/019d026d-87f6-763d-a4d8-9f979bbd856c.webp",
        "width": 640,
        "height": 457
      },
      "poi_business_url": "http://www.briarbush.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2494366989298184979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "briar-bush-nature-center",
      "poi_latitude": "40.122847",
      "poi_longitude": "-75.1281217",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 215-887-6603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIwW7HV2wxokREzOUoI_FnSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_37ffbbee-9347-4d0a-9728-d3e8a4f461ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Ambler Theater",
      "poi_type": "Entertainment",
      "poi_address": "108 E Butler Ave, Ambler, PA 19002, USA",
      "poi_short_description": "Nonprofit movie theater specializes in art & foreign films, plus kids' events & guest lecturers.",
      "poi_long_description": "Nonprofit movie theater specializes in art & foreign films, plus kids' events & guest lecturers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-8bba-70ee-b3dd-4079394c7437.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-8bba-70ee-b3dd-4079394c7437",
        "storage_key": "property/6767906449166357/019d026d-8bba-70ee-b3dd-4079394c7437.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "http://www.amblertheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4797157128645830130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ambler-theater",
      "poi_latitude": "40.1546417",
      "poi_longitude": "-75.2210857",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 215-345-7855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ce35-7701-8f56-4956673ae208.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ce35-7701-8f56-4956673ae208",
        "storage_key": "property/6767906449166357/019d026d-ce35-7701-8f56-4956673ae208.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJbexoBzm7xokR8uWq-P3skkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f78c7283-22b2-4575-86cc-8b72fda67866",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Act II Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "56 E Butler Ave, Ambler, PA 19002, USA",
      "poi_short_description": "Cozy venue for new, classic & contemporary plays & musicals, plus drama education programs.",
      "poi_long_description": "Cozy venue for new, classic & contemporary plays & musicals, plus drama education programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-8bb8-7003-882f-9892f7f17df3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-8bb8-7003-882f-9892f7f17df3",
        "storage_key": "property/6767906449166357/019d026d-8bb8-7003-882f-9892f7f17df3.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://act2.org/cms2/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16511044656143482467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "act-ii-playhouse",
      "poi_latitude": "40.154368",
      "poi_longitude": "-75.2219942",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 215-654-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT626_Di7xokRYz4LsKIDI-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_9af17d0e-1e8c-4efb-9da3-6ea15ee268e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Jefferson Abington Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1200 Old York Rd, Abington, PA 19001, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-8cde-7384-bb4b-b8bed3ff381e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-8cde-7384-bb4b-b8bed3ff381e",
        "storage_key": "property/6767906449166357/019d026d-8cde-7384-bb4b-b8bed3ff381e.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/abington-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4902426490968743372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-abington-hospital",
      "poi_latitude": "40.11906889999999",
      "poi_longitude": "-75.11990639999999",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 215-481-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ce7f-7098-a3a7-fd2a1a0df051.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ce7f-7098-a3a7-fd2a1a0df051",
        "storage_key": "property/6767906449166357/019d026d-ce7f-7098-a3a7-fd2a1a0df051.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWadklCwxokRzB2oW-vqCEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_edfd0ebd-d5cf-4e9a-84b8-6f73afb77cc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Liberty Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "401 Horsham Rd 1st Floor, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-8f81-731e-a80a-622d74a6fd92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-8f81-731e-a80a-622d74a6fd92",
        "storage_key": "property/6767906449166357/019d026d-8f81-731e-a80a-622d74a6fd92.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.libertyucc.com/?utm_source=GMB&utm_medium=Website",
      "poi_directions_map_url": "https://maps.google.com/?cid=13576331758873346242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "liberty-urgent-care",
      "poi_latitude": "40.1828656",
      "poi_longitude": "-75.1378919",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-422-3646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwvPSZGvxokRwgCA4M3RaLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_4610f629-c636-40cb-b40c-feb9eb490724",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "AFC Urgent Care Willow Grove",
      "poi_type": "Health and Wellness",
      "poi_address": "2848 W Moreland Rd, Willow Grove, PA 19090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-9345-73dc-82f4-1c1b723b3cc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-9345-73dc-82f4-1c1b723b3cc1",
        "storage_key": "property/6767906449166357/019d026d-9345-73dc-82f4-1c1b723b3cc1.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.afcurgentcare.com/willowgrove/?utm_source=gmb&utm_medium=organic&utm_campaign=willowgrove",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614481818108390011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-willow-grove",
      "poi_latitude": "40.14751529999999",
      "poi_longitude": "-75.1281687",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 267-495-5455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhe2cByOwxokRe2pduRRb8Lw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_ec8d6ca1-d545-4285-888c-4b2c90beab57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Pharmacy of Hatboro",
      "poi_type": "Health and Wellness",
      "poi_address": "420 S York Rd Suite D, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-930e-772f-9625-32d388d0cd19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-930e-772f-9625-32d388d0cd19",
        "storage_key": "property/6767906449166357/019d026d-930e-772f-9625-32d388d0cd19.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pharmacyhatboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12663292341566587655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pharmacy-of-hatboro",
      "poi_latitude": "40.1705526",
      "poi_longitude": "-75.1115824",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-443-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ce7e-741c-9e1a-9ece3b8ec951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ce7e-741c-9e1a-9ece3b8ec951",
        "storage_key": "property/6767906449166357/019d026d-ce7e-741c-9e1a-9ece3b8ec951.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ676ussuvxokRB0MAqkoNva8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_fc1f5be3-1a36-4da6-a53b-4d1048a9d0ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Horsham pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "316 Horsham Rd suite E, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-94a8-713c-936e-28e1eb540d47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-94a8-713c-936e-28e1eb540d47",
        "storage_key": "property/6767906449166357/019d026d-94a8-713c-936e-28e1eb540d47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://horshamrx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2546701492422168372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "horsham-pharmacy",
      "poi_latitude": "40.181913",
      "poi_longitude": "-75.1351549",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 267-282-5747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ce7e-741c-9e1a-9ece3b8ec951.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ce7e-741c-9e1a-9ece3b8ec951",
        "storage_key": "property/6767906449166357/019d026d-ce7e-741c-9e1a-9ece3b8ec951.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzT072_KvxokRNM_HrIOzVyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_af05ad22-10e5-433a-868a-3bf0c73e0a61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "NovaCare Rehabilitation - Hatboro",
      "poi_type": "Health and Wellness",
      "poi_address": "444 N York Rd # A-1, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-996c-7300-bab6-2c8e1bbb354e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-996c-7300-bab6-2c8e1bbb354e",
        "storage_key": "property/6767906449166357/019d026d-996c-7300-bab6-2c8e1bbb354e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.novacare.com/contact/find-a-location/pa/hatboro/hatboro/?ty=xt",
      "poi_directions_map_url": "https://maps.google.com/?cid=7643242480893655311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novacare-rehabilitation---hatboro",
      "poi_latitude": "40.1852976",
      "poi_longitude": "-75.1032981",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-444-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNcXQu1OuxokRD3nXbYpAEmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_31407367-ec48-4a28-a557-90f86cf86b7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Nourishing Storm Yoga Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "122 N York Rd STE 6, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-998c-7284-ad6e-efdc365bad30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-998c-7284-ad6e-efdc365bad30",
        "storage_key": "property/6767906449166357/019d026d-998c-7284-ad6e-efdc365bad30.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://nourishingstorm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7084942556084994517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nourishing-storm-yoga-studio",
      "poi_latitude": "40.1800635",
      "poi_longitude": "-75.1047869",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-394-8152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0X_ZDk2uxokR1YF-lbfFUmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_be3d7406-5ef9-465e-89de-335880e72dd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Horsham Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "400 Horsham Rd, Horsham, PA 19044, USA",
      "poi_short_description": "Clean athletic club offering a variety of workouts from classes to yoga to personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-9951-762f-99d5-aca48181c6ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-9951-762f-99d5-aca48181c6ee",
        "storage_key": "property/6767906449166357/019d026d-9951-762f-99d5-aca48181c6ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://horshamathletic.com/?utm_source=gmb&utm_medium=profile&utm_campaign=1seosm_link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13383866494320058547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "horsham-athletic-club",
      "poi_latitude": "40.183998",
      "poi_longitude": "-75.1367413",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-675-4535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBeBLKpevxokRsyAzc6oLvbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_1478d66d-0c5f-467d-8af2-de9a91ddd5ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Willow Grove YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Davisville Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-9b77-74d0-85ef-f98ae0362b1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-9b77-74d0-85ef-f98ae0362b1a",
        "storage_key": "property/6767906449166357/019d026d-9b77-74d0-85ef-f98ae0362b1a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.philaymca.org/locations/willow-grove-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=9341815488532329185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-grove-ymca",
      "poi_latitude": "40.1593883",
      "poi_longitude": "-75.101931",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-392-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQj2U76vxokR4TI2F7HLpIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0406eab4-18bc-4a62-991a-a5f867afed4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Hatboro Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "330 W Moreland Ave, Hatboro, PA 19040, USA",
      "poi_short_description": "Recreational area offering facilities for baseball and basketball, plus a playground and pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-9e45-77ed-a43b-b46e4b9c0beb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-9e45-77ed-a43b-b46e4b9c0beb",
        "storage_key": "property/6767906449166357/019d026d-9e45-77ed-a43b-b46e4b9c0beb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9335641430551014077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatboro-memorial-park",
      "poi_latitude": "40.1816432",
      "poi_longitude": "-75.1109352",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbn-XrKvxokRvappMmvcjoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bebc75f7-382a-4fdc-9172-478b89513033",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Eaton Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "61 W Moreland Ave, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-9edb-7373-9331-ac98a882e5bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-9edb-7373-9331-ac98a882e5bc",
        "storage_key": "property/6767906449166357/019d026d-9edb-7373-9331-ac98a882e5bc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3462923667220526469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eaton-memorial-park",
      "poi_latitude": "40.1791036",
      "poi_longitude": "-75.1118475",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAlLOvxokRhfX4XLrGDjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_727b4d31-9dc7-4ff4-adc9-5e914c1e1428",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Tanner Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "329 Jefferson Ave, Hatboro, PA 19040, USA",
      "poi_short_description": "Basketball courts in a small facility for children with slides, swings and a seesaw.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-a0b4-7228-988a-197a13172db2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-a0b4-7228-988a-197a13172db2",
        "storage_key": "property/6767906449166357/019d026d-a0b4-7228-988a-197a13172db2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=86621945751116314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanner-park",
      "poi_latitude": "40.180442",
      "poi_longitude": "-75.095456",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-443-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Q8bUEWuxokRGpo_YjO-MwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_639dac2e-58b9-4c59-ae33-179cfc5dd357",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Miller Meadow",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "S York Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Kids-friendly park that's mostly meadow dotted with benches, plus an outdoor gazebo.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-a222-74a9-ad96-f9983dfa0c78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-a222-74a9-ad96-f9983dfa0c78",
        "storage_key": "property/6767906449166357/019d026d-a222-74a9-ad96-f9983dfa0c78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16067384232511991161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miller-meadow",
      "poi_latitude": "40.170912",
      "poi_longitude": "-75.1094335",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-443-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8S77MqvxokRee2WsNTQ-t4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_844c1b3b-eca2-4198-a359-108481d5bb3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Pennypack Community Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "130 Spring Ave, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-a871-76e4-912b-bdcc0b77cdee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-a871-76e4-912b-bdcc0b77cdee",
        "storage_key": "property/6767906449166357/019d026d-a871-76e4-912b-bdcc0b77cdee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://myhatboro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8394468269625478010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennypack-community-center",
      "poi_latitude": "40.1739198",
      "poi_longitude": "-75.1110289",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-443-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz1Vr-qOvxokReotQWWokf3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_377dc7f1-8ebc-4ec6-9ad5-8e7b58bbc8ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Celano Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-aa83-762e-bd76-b09e802d1dbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-aa83-762e-bd76-b09e802d1dbd",
        "storage_key": "property/6767906449166357/019d026d-aa83-762e-bd76-b09e802d1dbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9165398791409504796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "celano-park",
      "poi_latitude": "40.1846119",
      "poi_longitude": "-75.10140059999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL1Lg3P2vxokRHBLC8qMJMn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_28f15bff-4d8d-4868-b30e-fd315b81fc2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Hatboro Little League",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2 Blair Mill Rd, Hatboro, PA 19040, USA",
      "poi_short_description": "Baseball field for kids with scoreboards and a snack stand, plus a clean restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-a69d-72de-9ee0-314bd1a1bf8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-a69d-72de-9ee0-314bd1a1bf8f",
        "storage_key": "property/6767906449166357/019d026d-a69d-72de-9ee0-314bd1a1bf8f.webp",
        "width": 1123,
        "height": 1280
      },
      "poi_business_url": "https://www.hatborolittleleague.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4448715814113812364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatboro-little-league",
      "poi_latitude": "40.1897286",
      "poi_longitude": "-75.1095084",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 215-674-4428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOVcH2qqvxokRjJ_qbnYDvT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "custom_2c45c76c-061c-4721-ad1a-59c9d0c1cdb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Warminster Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Veterans Way, Warminster, PA 18974, USA",
      "poi_short_description": "Large park featuring walking trails, a picnic area, a pond & a playground pavilion.",
      "poi_long_description": "Large park featuring walking trails, a picnic area, a pond & a playground pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-aa76-723b-bf59-e1fc55e2a403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-aa76-723b-bf59-e1fc55e2a403",
        "storage_key": "property/6767906449166357/019d026d-aa76-723b-bf59-e1fc55e2a403.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13084027829947052796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "warminster-community-park",
      "poi_latitude": "40.200088",
      "poi_longitude": "-75.0596545",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 215-443-5428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZ13nJ2uxokR_LJRO_3Nk7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ea6f0a8e-6a30-4fef-af43-4376dad7dd33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Kemper Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "905 Valley Rd, Warminster, PA 18974, USA",
      "poi_short_description": "Grassy area around a creek, featuring a playground plus benches and picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-afaf-77ea-a26d-6451053fb553.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-afaf-77ea-a26d-6451053fb553",
        "storage_key": "property/6767906449166357/019d026d-afaf-77ea-a26d-6451053fb553.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4472201119056544661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemper-park",
      "poi_latitude": "40.2287504",
      "poi_longitude": "-75.118416",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-443-5428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJyQfJiyvxokRlUN4GTlzED4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_98733d18-a8f0-4f83-ae30-1f919caad3ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Buehler Park Nature Study Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "627 Fitzwatertown Rd, Willow Grove, PA 19090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-b36f-75e9-a1ff-edaf8bd204bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-b36f-75e9-a1ff-edaf8bd204bb",
        "storage_key": "property/6767906449166357/019d026d-b36f-75e9-a1ff-edaf8bd204bb.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15148118602238972234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buehler-park-nature-study-area",
      "poi_latitude": "40.1566105",
      "poi_longitude": "-75.11994729999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-659-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cb53-74ad-9afb-c640622ea135",
        "storage_key": "property/6767906449166357/019d026d-cb53-74ad-9afb-c640622ea135.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm9bfhdevxokRStHwTZztONI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_01f1a7d4-2e9d-486e-984f-16dd542d5f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Hatboro",
      "poi_type": "Transportation & Transit",
      "poi_address": "40 S Penn St, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-b0d4-714b-8c73-768170a72dc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-b0d4-714b-8c73-768170a72dc6",
        "storage_key": "property/6767906449166357/019d026d-b0d4-714b-8c73-768170a72dc6.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "http://www.septa.org/stations/rail/hatboro.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4938197627698174781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatboro",
      "poi_latitude": "40.1756315",
      "poi_longitude": "-75.10294309999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cec3-707f-8fd6-d06075696d94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cec3-707f-8fd6-d06075696d94",
        "storage_key": "property/6767906449166357/019d026d-cec3-707f-8fd6-d06075696d94.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZBP5EuuxokRPVugJZQAiEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_379cb6a6-7031-4458-b18f-76d3b55ac432",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Warminster",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 Station Drive, Warminster, PA 18974, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-b3ec-7209-b4b6-7fc67f8b3ffc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-b3ec-7209-b4b6-7fc67f8b3ffc",
        "storage_key": "property/6767906449166357/019d026d-b3ec-7209-b4b6-7fc67f8b3ffc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17744445651809381347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "warminster",
      "poi_latitude": "40.1950946",
      "poi_longitude": "-75.08893119999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cec3-707f-8fd6-d06075696d94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cec3-707f-8fd6-d06075696d94",
        "storage_key": "property/6767906449166357/019d026d-cec3-707f-8fd6-d06075696d94.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTnECvSuxokR46tSZE7vQPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_b0a84b3a-6bdb-41b7-a365-1ca796263a44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Willow Grove",
      "poi_type": "Transportation & Transit",
      "poi_address": "215 Davisville Rd, Willow Grove, PA 19090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-b757-7475-bf49-2e9d02de010c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-b757-7475-bf49-2e9d02de010c",
        "storage_key": "property/6767906449166357/019d026d-b757-7475-bf49-2e9d02de010c.webp",
        "width": 916,
        "height": 525
      },
      "poi_business_url": "http://www.septa.org/stations/rail/willowgrove.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11281485490488013611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-grove",
      "poi_latitude": "40.1436482",
      "poi_longitude": "-75.1142732",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cec3-707f-8fd6-d06075696d94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cec3-707f-8fd6-d06075696d94",
        "storage_key": "property/6767906449166357/019d026d-cec3-707f-8fd6-d06075696d94.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyKoBi6wxokRK_NCH0jjj5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_2d9711e7-e8c8-4713-a519-2838f235aeb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Willow Grove Park Mall",
      "poi_type": "Transportation & Transit",
      "poi_address": "Willow Grove, PA 19090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-b884-7126-ba17-4182c66b383f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-b884-7126-ba17-4182c66b383f",
        "storage_key": "property/6767906449166357/019d026d-b884-7126-ba17-4182c66b383f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17331625273925054252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-grove-park-mall",
      "poi_latitude": "40.1422385",
      "poi_longitude": "-75.12230350000002",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6b_uATuwxokRLC98GFxNhvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_1f55f761-cd34-474f-aff6-a42b20c5e64b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Municipal Parking",
      "poi_type": "Transportation & Transit",
      "poi_address": "25 W Moreland Ave, Hatboro, PA 19040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14491038019922781963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "municipal-parking",
      "poi_latitude": "40.1773766",
      "poi_longitude": "-75.10679689999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-d322-722a-8b26-a0d71483a1f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-d322-722a-8b26-a0d71483a1f7",
        "storage_key": "property/6767906449166357/019d026d-d322-722a-8b26-a0d71483a1f7.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_86lWUuuxokRC2ctZE2CGsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking"
    },
    {
      "id": "custom_e043e483-3015-41c5-9863-60a3c7c84ddd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "PA Turnpike Willow Grove Interchange Exit 343",
      "poi_type": "Transportation & Transit",
      "poi_address": "I-276 at, PA-611, Willow Grove, PA 19090, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-bac3-7108-a199-d2028a5b1c01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-bac3-7108-a199-d2028a5b1c01",
        "storage_key": "property/6767906449166357/019d026d-bac3-7108-a199-d2028a5b1c01.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.paturnpike.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1641867270639404443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pa-turnpike-willow-grove-interchange-exit-343",
      "poi_latitude": "40.1636266",
      "poi_longitude": "-75.121049",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-331-3414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE97Bk8OvxokRm0XNapUVyRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9c59a638-67b4-4169-bc2a-06f24fae3494",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Philadelphia International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8500 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_long_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-b96a-72a9-b49b-7e8d75de32ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-b96a-72a9-b49b-7e8d75de32ee",
        "storage_key": "property/6767906449166357/019d026d-b96a-72a9-b49b-7e8d75de32ee.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4480542405857629144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philadelphia-international-airport",
      "poi_latitude": "39.87297969999999",
      "poi_longitude": "-75.24369870000001",
      "poi_miles_from_property": "30",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "2 hours 44 mins",
      "poi_driving_minutes": "44 mins",
      "poi_business_phone": "+1 215-937-6937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-d37a-745a-9a77-786dca9b3f5e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-d37a-745a-9a77-786dca9b3f5e",
        "storage_key": "property/6767906449166357/019d026d-d37a-745a-9a77-786dca9b3f5e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4OpYGbExokR2NM3RpQVLj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_0b059c1e-1f55-4ffd-a68e-ed5dda840859",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Jefferson Lansdale Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Medical Campus Dr, Lansdale, PA 19446, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-bd01-76fb-9e24-99b05fe05573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-bd01-76fb-9e24-99b05fe05573",
        "storage_key": "property/6767906449166357/019d026d-bd01-76fb-9e24-99b05fe05573.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/jefferson-lansdale-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1996463513549832306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-lansdale-hospital",
      "poi_latitude": "40.2504115",
      "poi_longitude": "-75.2714216",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 215-368-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-ce7f-7098-a3a7-fd2a1a0df051.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-ce7f-7098-a3a7-fd2a1a0df051",
        "storage_key": "property/6767906449166357/019d026d-ce7f-7098-a3a7-fd2a1a0df051.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJs50JId6jxokRcoAq5PzctBs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cd40dbed-a9e0-4dee-8bc8-871213e7b29e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Temple University Ambler Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "580 Meetinghouse Rd, Ambler, PA 19002, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-bdee-76fb-b037-3459933f24b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-bdee-76fb-b037-3459933f24b0",
        "storage_key": "property/6767906449166357/019d026d-bdee-76fb-b037-3459933f24b0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.temple.edu/ambler/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3865597635696637842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "temple-university-ambler-campus",
      "poi_latitude": "40.1641832",
      "poi_longitude": "-75.1925883",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 267-468-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi9AiCS2lxokRkrdJoJFcpTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_eb47ea7a-3438-4ffd-88f6-e4aa71212145",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Hatboro-Horsham School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "229 Meetinghouse Rd, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.hatboro-horsham.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13551650503779842185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatboro-horsham-school-district",
      "poi_latitude": "40.1848411",
      "poi_longitude": "-75.12869189999999",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-420-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-cad0-767f-8fd5-75a5456be851",
        "storage_key": "property/6767906449166357/019d026d-cad0-767f-8fd5-75a5456be851.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRa4OGL2vxokRiXgKXlUiEbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a41e36f1-e305-4a26-8889-633429839386",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "The Penn Mutual Life Insurance Company",
      "poi_type": "Major Employers & Offices",
      "poi_address": "161 Washington St 11th Floor, Suite 1111, Conshohocken, PA 19428, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-bead-7379-bf0c-a8c228689338.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-bead-7379-bf0c-a8c228689338",
        "storage_key": "property/6767906449166357/019d026d-bead-7379-bf0c-a8c228689338.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.pennmutual.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13084687390517068990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-penn-mutual-life-insurance-company",
      "poi_latitude": "40.0712712",
      "poi_longitude": "-75.3077364",
      "poi_miles_from_property": "14.4",
      "poi_walking_minutes": "5 hours 19 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 800-523-0650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJldtt-PCvxokRvoTNJNsllrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_c9c51733-e96a-417c-9aa4-e092b965d196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Toll Brothers Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1140 Virginia Dr, Fort Washington, PA 19034, USA",
      "poi_short_description": "Home builder offering real estate development services and country clubs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c0af-70ed-baa3-de2f2ff3b48b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-c0af-70ed-baa3-de2f2ff3b48b",
        "storage_key": "property/6767906449166357/019d026d-c0af-70ed-baa3-de2f2ff3b48b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.tollbrothers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14115845773278848493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toll-brothers-corporate-office",
      "poi_latitude": "40.1391059",
      "poi_longitude": "-75.1798527",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-938-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjcdIbOuvxokR7SV8HPGO5cM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_f1c25ba2-4ad3-4533-9283-017a94fc75e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Bimbo bakeries warehouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "250 Dunksferry Rd, Bensalem, PA 19020, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5787516914410327367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bimbo-bakeries-warehouse",
      "poi_latitude": "40.0761022",
      "poi_longitude": "-74.9231576",
      "poi_miles_from_property": "14.6",
      "poi_walking_minutes": "5 hours 24 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 315-259-3485",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbWVbj4JNwYkRRw3-VvhjUVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_617f8a94-dd05-46b9-9be9-48c29cfd1924",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "Janssen Biotech, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 Ridgeview Dr, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c22a-73ea-a341-2ef3c8672784.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d026d-c22a-73ea-a341-2ef3c8672784",
        "storage_key": "property/6767906449166357/019d026d-c22a-73ea-a341-2ef3c8672784.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.janssen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4119574513111226278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "janssen-biotech-inc",
      "poi_latitude": "40.1970557",
      "poi_longitude": "-75.15624199999999",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK7W6LIClxokRple_dzGrKzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_29adf7c2-b036-499e-beef-7e2746f493fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "poi_name": "UnitedHealth Group",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4 Walnut Grove Dr, Horsham, PA 19044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14467267039135536331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unitedhealth-group",
      "poi_latitude": "40.1655121",
      "poi_longitude": "-75.14005",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026d-c6bb-7533-b1f4-1e32bab01aa8",
        "storage_key": "property/6767906449166357/019d026d-c6bb-7533-b1f4-1e32bab01aa8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3eG-CuWvxokRyxRkorgOxsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d22d2e3f4e75b8968e56d4db",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a3d7d0fccae289fff32613a5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f34cc3dc76a477b7f3be4789",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_22ea9f135e9e275baa687d43",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_852f2c6f6952aa06935c0db2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_354dd3a48d28cdb7c9f6ad03",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_d5c73be3f22660b86e238041",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "rating": "5",
      "name": "false",
      "text": "My wife and I have been living at Wellington for around 7 months now. We enjoy the landscape and the attention to detail the Wellington staff takes. Our apartment if perfect for us. The neighbors are nice and the staff is very attentive. I love living at a place that is friendly. People are always walking dogs, taking advantage of the dog park by the pool. I have lived in apartments where people don't talk to each other and we are glad we have found a place the makes us feel at home. Kitchen came like new nice cabinets and appliances. The laundry situation is smooth we don't have to go outside to do it just go downstairs and there are multiple machines which helps. Overall it has been great living at Wellington, my wife and I will probably stay for the next couple of years. \n\n-Jeremy Gonzalez",
      "date": "false",
      "title": "Living Review"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_01277218-7808-429e-97d7-606076b70386",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-6855-728a-ab5a-b7f1864a9021.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, wood cabinets, and a subway tile backsplash.",
        "public_id": "019fd931-6855-728a-ab5a-b7f1864a9021",
        "storage_key": "property/6767906449166357/019fd931-6855-728a-ab5a-b7f1864a9021.webp",
        "width": 1920,
        "height": 1282
      },
      "virtual_tour_title": "360 Tours",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=636269924bee3140b5eec61d&sourceId=1001"
    },
    {
      "id": "custom_0e691e38-f803-4cf5-8eea-59762d76b65b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-1606-7097-93c1-36e4ba879f98.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with dark cabinetry, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019d026f-1606-7097-93c1-36e4ba879f98",
        "storage_key": "property/6767906449166357/019d026f-1606-7097-93c1-36e4ba879f98.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 800 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7fYoTYnmYLC"
    },
    {
      "id": "custom_4a2030ce-ae50-4155-b235-081171d57f02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-1608-7348-a419-59d82859c3d0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with gas stove, microwave, dishwasher, sink, refrigerator and light wood cabinets.",
        "public_id": "019d026f-1608-7348-a419-59d82859c3d0",
        "storage_key": "property/6767906449166357/019d026f-1608-7348-a419-59d82859c3d0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 800 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=y8Mmsn9XpfB"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_f249695eeb0c821d4742151f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "429159",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_316ece7981fb14749d1a4f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "429161",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1e2c76bf50199d2ee9adf90e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "429163",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_607e63d92cff9c853ef11ae9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "429164",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8f071874b1cde33ccc35e038",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "429166",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_727517eaca2478f70fb6104d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "429167",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4803c6503970bfb5dc3351b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "429170",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fa6a26e53acf1babb15eef69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "429173",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ec5c6b42503bf0e3578c42af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "572099",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6a228b534b3a64c4b30207e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "572100",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_305c17122273953141164d91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "572101",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9e6e8c520eedc2cc2b334f0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "572102",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_00520a1b817901937bbc1e37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "572103",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6610eb81c7e7532e19cbef73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "572104",
      "name": "Trash Service",
      "description": "false",
      "amount": 12,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ad66916683a7f135cc4abe5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "835296",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_db5a89f0559306f38029076d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "835299",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ae3e609058860b170134c64b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "835306",
      "name": "Admin Fee",
      "description": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant.",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_53f6c62533144c6075a7503a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "835308",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eda6921174fa5e724721103d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "835318",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_922fe40d602779a985e5c133",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "engrain",
      "external_id": "835319",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a2886-0627-750d-a24b-973525ac9a9b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-the-wellington-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357"
    },
    {
      "lead_collector_id": "019c3043-b846-7782-a3ea-968042e948c7",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-wellington",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357"
    },
    {
      "lead_collector_id": "019c3043-b8b7-7518-a2da-541c69ffdf49",
      "lead_source": "LANDING_PAGE",
      "name": "the-wellington",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "pool-apartments-hatboro-pa-wellington-21",
      "search_query": "pool apartments in Hatboro PA",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Hatboro, PA",
      "h2_subtitle": "Discover premium poolside living at The Wellington in Hatboro, PA. Explore spacious apartments with exceptional community amenities today.",
      "page_copy": "Welcome to The Wellington, your destination for pool apartments in Hatboro, PA. Dive into luxury and comfort with our stunning pool that offers a perfect oasis for relaxation and recreation. Located in the vibrant neighborhood of Horsham/Willow Grove, our community is nestled in Montgomery County, providing a serene yet conveniently accessible living environment. \n\nAt The Wellington, we offer spacious one, two, and three-bedroom floor plans complemented by modern amenities such as a fitness center, dog park, and playground. Enjoy the ease of cable-ready residences with private balconies, ideal for enjoying the outdoors. Whether you're lounging by the pool or exploring the local area, The Wellington combines style and practicality, making it the perfect home for those seeking a blend of luxury and tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Hatboro, PA",
      "seo_description": "Find premium pool apartments in Hatboro, PA at The Wellington. Enjoy community amenities like a pool, fitness center, and more. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-dog-park-horsham-willow-grove-871",
      "search_query": "dog-friendly apartments with dog park Horsham Willow Grove",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments Near Horsham",
      "h2_subtitle": "Experience pet-friendly living with a dog park at The Wellington. Located in the Horsham/Willow Grove area, perfect for you and your pet.",
      "page_copy": "Find your ideal dog-friendly apartment with a dog park in the Horsham/Willow Grove area at The Wellington. Our welcoming community is committed to providing a comfortable environment for both you and your furry companions. The on-site dog park is a fantastic space where your pets can run and play safely, ensuring they enjoy their new home as much as you do.\n\nLocated in Hatboro, PA, The Wellington offers spacious one, two, and three-bedroom apartments complete with modern amenities such as a fitness center, playground, and a sparkling pool. All units feature hardwood floors and are cable-ready, while select units include balconies, perfect for relaxing after a long day. Discover the unmatched convenience and friendly atmosphere of The Wellington today, where comfort and easy living go hand in hand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Near Horsham",
      "seo_description": "Explore dog-friendly apartments with a dog park at The Wellington. Enjoy amenities like a pool and playground. Perfect for you and your pets near Horsham.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "luxury-apartments-fitness-center-montgomery-county-571",
      "search_query": "luxury apartments with fitness center Montgomery County PA",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Discover luxurious living at The Wellington in Montgomery County, PA. Our fitness center caters to an active lifestyle.",
      "page_copy": "Welcome to The Wellington, where luxury meets fitness in Montgomery County, PA. Our community is designed for those who crave a blend of elegance and activity in their lives. With a state-of-the-art fitness center on site, staying on top of your workout routine is both convenient and enjoyable. \n\nThe Wellington offers spacious one, two, and three-bedroom apartments equipped with premium finishes like hardwood floors and private balconies. Beyond the luxurious interiors, our community features exceptional amenities, including a stunning pool, meticulously maintained dog park, and a playground, ensuring both relaxation and recreation are just steps away. Located in the tranquil yet accessible area of Horsham/Willow Grove, we provide the perfect home base for experiencing all that Montgomery County has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments in Montgomery County, PA",
      "seo_description": "Discover luxury apartments with a fitness center at The Wellington in Montgomery County, PA. Enjoy top amenities like a pool and dog park. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartment-in-unit-washer-dryer-hatboro-pa-516",
      "search_query": "apartment with in-unit washer dryer Hatboro PA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Enjoy the convenience of in-unit washer dryer amenities at The Wellington in Hatboro, PA. Discover our modern apartment features today.",
      "page_copy": "At The Wellington, discover the convenience of having an apartment with an in-unit washer dryer in Hatboro, PA. We understand the importance of modern conveniences, and our community is designed to meet your lifestyle needs with efficiency and style. \n\nOur spacious one, two, and three-bedroom apartments boast not just in-unit washer and dryer setups but also other contemporary features like hardwood floors, balconies, and cable-ready units. Residents enjoy access to a host of community amenities, such as a sparkling swimming pool, a well-equipped fitness center, a dog park for pet lovers, and a playground. Situated in the vibrant Horsham/Willow Grove area, The Wellington offers the perfect blend of comfort and accessibility, making it an ideal choice for your next home in Montgomery County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Washer Dryer in Hatboro",
      "seo_description": "Find apartments with in-unit washer dryer in Hatboro, PA at The Wellington. Enjoy modern amenities and convenience. Explore our available units today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-air-conditioning-dishwasher-19040-587",
      "search_query": "apartments with air conditioning and dishwasher 19040",
      "category": "Amenity",
      "h1_title": "Apartments with A/C and Dishwasher",
      "h2_subtitle": "Enjoy modern living with air conditioning and dishwashers in apartments at The Wellington. Experience comfort and ease in the 19040 area.",
      "page_copy": "Discover your ideal home at The Wellington, where apartments come equipped with essential features like air conditioning and dishwashers, bringing comfort and convenience to life in the 19040 area. Our thoughtfully designed living spaces ensure you enjoy a relaxed and hassle-free lifestyle.\n\nChoose from our selection of one, two, and three-bedroom floor plans, each featuring hardwood floors and options for balconies, perfect for a breath of fresh air. Beyond the modern interiors, The Wellington offers a wealth of community amenities, including a sparkling pool, a fitness center, a playground, and a dog park, catering to all lifestyles. Located in Hatboro, PA, within the vibrant Horsham/Willow Grove neighborhood, our community provides easy access to everything Montgomery County offers. Experience cozy living in style and schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Comfortable A/C and Dishwasher Apartments",
      "seo_description": "Explore apartments with A/C and dishwashers in Hatboro's 19040 area. Enjoy modern amenities at The Wellington. Discover your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-hatboro-pa-865",
      "search_query": "one bedroom apartments Hatboro PA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Hatboro, PA",
      "h2_subtitle": "Explore comfortable one bedroom apartments at The Wellington. Located in Hatboro, PA, perfect for a cozy lifestyle.",
      "page_copy": "The Wellington offers an exceptional selection of one bedroom apartments in Hatboro, PA. Designed with comfort and style in mind, our residences feature essential amenities and quality finishes, making them perfect for singles and couples alike. Each apartment comes with hardwood floors and a private balcony, providing an ideal retreat after a busy day.\n\nResidents enjoy a host of community amenities, including a state-of-the-art fitness center, a large pool for relaxation, a dog park, and a playground perfect for families. Situated in the Horsham/Willow Grove neighborhood, The Wellington offers a vibrant community feel with convenient access to shops, dining, and entertainment in Montgomery County. Discover the perfect blend of comfort and convenience in our one-bedroom options, and schedule a tour to see all that we have to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Hatboro, PA",
      "seo_description": "Find comfortable one bedroom apartments in Hatboro, PA at The Wellington. Enjoy relaxing amenities and vibrant community life. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-montgomery-county-939",
      "search_query": "two bedroom apartments Montgomery County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Montgomery County",
      "h2_subtitle": "Discover spacious two bedroom apartments at The Wellington. Located in the heart of Montgomery County, offering modern amenities and comfort.",
      "page_copy": "At The Wellington, find the perfect two bedroom apartments nestled in the heart of Montgomery County. Each residence is designed with your comfort in mind, featuring spacious layouts with hardwood floors and private balconies. Our apartments are cable ready and offer a modern lifestyle with essential amenities, including air conditioning and dishwashers.\n\nExperience the convenience of community living with a full suite of amenities at your doorstep. Enjoy a relaxing dip in the pool, work out at the fitness center, or take your furry friend to the dog park. Families will love the on-site playground, making The Wellington a great choice for everyone. Situated in the vibrant Horsham/Willow Grove area of Hatboro, PA, this community provides easy access to local dining, shopping, and entertainment. Schedule a visit to see how these two-bedroom apartments can become your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Two Bedroom Apartments Montgomery County",
      "seo_description": "Explore two bedroom apartments in Montgomery County at The Wellington. Enjoy modern amenities and the vibrant Hatboro community. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "three-bedroom-floorplans-near-19040-946",
      "search_query": "three bedroom floorplans near 19040",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Floorplans Near 19040",
      "h2_subtitle": "Find expansive three bedroom floorplans at The Wellington, conveniently located near the 19040 area. Perfect for larger households.",
      "page_copy": "Explore the spacious three bedroom floorplans at The Wellington, ideal for families or those needing extra space. Situated conveniently near the 19040 area, our community provides a modern living experience. Each unit is designed with comfort and functionality in mind, boasting features like hardwood floors, balconies, air conditioning, and in-unit dishwashers to make life effortless.\n\nOur community amenities enhance the living experience with a sparkling pool, fitness center, dog park, and playground on-site, catering to a variety of lifestyles. Located in the heart of the Horsham/Willow Grove area in Hatboro, PA, The Wellington offers easy access to exceptional local amenities and attractions throughout Montgomery County. Schedule a tour today to see why The Wellington is the perfect place for your next move!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Floorplans Near 19040",
      "seo_description": "Discover spacious three bedroom floorplans near 19040 at The Wellington. Enjoy modern amenities and a vibrant community. Visit The Wellington today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-near-crooked-billet-elementary-610",
      "search_query": "apartments near Crooked Billet Elementary School Hatboro PA",
      "category": "School",
      "h1_title": "Apartments Near Crooked Billet Elementary",
      "h2_subtitle": "Find family-friendly apartments near Crooked Billet Elementary in Hatboro, PA. The Wellington offers convenient and comfortable living.",
      "page_copy": "The Wellington is the ideal community for families seeking apartments near Crooked Billet Elementary School in Hatboro, PA. Located just minutes away, our community ensures easy commutes and a supportive environment for families with school-aged children. Our one, two, and three-bedroom apartments offer flexible living arrangements tailored to various needs and are equipped with hardwood floors, balconies, and modern conveniences.\n\nIn addition to proximity to Crooked Billet Elementary, residents enjoy excellent amenities designed for every family member. Spend weekends at our playground, take a dip in the pool, work out in the fitness center, or enjoy the dog park with your furry friend. Nestled in the vibrant Horsham/Willow Grove neighborhood, The Wellington also provides easy access to shopping, dining, and entertainment options across Montgomery County. Schedule a visit today to see why our location and community are perfect for you and your family!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Crooked Billet Elementary School",
      "seo_description": "Find ideal family-friendly apartments near Crooked Billet Elementary in Hatboro, PA, at The Wellington. Enjoy modern living and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "rentals-close-to-blair-mill-elementary-815",
      "search_query": "rentals close to Blair Mill Elementary Montgomery County",
      "category": "School",
      "h1_title": "Rentals Close to Blair Mill Elementary",
      "h2_subtitle": "Discover rentals near Blair Mill Elementary in Montgomery County. Enjoy convenience and comfort at The Wellington.",
      "page_copy": "The Wellington offers the perfect place for families seeking rentals close to Blair Mill Elementary School in Montgomery County. Our community features spacious one, two, and three-bedroom floor plans, providing ample options tailored to meet the needs of growing families. Each apartment comes equipped with modern amenities such as cable readiness, hardwood floors, and private balconies.\n\nBeyond our apartment interiors, residents enjoy a range of community amenities for a well-rounded living experience. Our on-site playground, refreshing pool, and well-equipped fitness center are just a few of the features awaiting you. Located in the Horsham/Willow Grove area of Hatboro, PA, The Wellington is conveniently situated for easy access to local schools, shopping centers, and entertainment venues, making it a top choice for families. Come and tour our community today to see why it's the perfect place to call home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Blair Mill Elementary School",
      "seo_description": "Explore rentals near Blair Mill Elementary in Montgomery County at The Wellington. Enjoy spacious layouts and modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "keith-valley-middle-school-apartments-846",
      "search_query": "Keith Valley Middle School proximity apartments",
      "category": "School",
      "h1_title": "Proximity Apartments to Keith Valley Middle School",
      "h2_subtitle": "Experience the convenience of living in proximity to Keith Valley Middle School with spacious apartment options at The Wellington.",
      "page_copy": "The Wellington offers prime apartment options for families desiring proximity to Keith Valley Middle School. Our community boasts a range of one to three-bedroom units, ideal for ensuring a comfortable lifestyle with easy access to education. Located in the heart of Hatboro's Horsham/Willow Grove neighborhood, our apartments provide modern living with features like hardwood floors, cable readiness, and private balconies.\n\nBeyond our thoughtfully designed interiors, The Wellington is home to numerous amenities suited for everyone in the family. Enjoy our inviting pool, fitness center, and on-site playground, perfect for children and adults alike. Our location in Montgomery County offers residents convenient access not only to Keith Valley Middle School but also to a wide range of shopping, dining, and recreational activities. Discover why The Wellington is the ultimate choice for school and community proximity by scheduling your tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Keith Valley Middle School Proximity Apartments",
      "seo_description": "Find convenient apartments near Keith Valley Middle School at The Wellington. Enjoy modern amenities and family-friendly living in Hatboro, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "hatboro-horsham-high-school-nearby-rentals-152",
      "search_query": "Hatboro-Horsham Senior High School nearby rentals",
      "category": "School",
      "h1_title": "Nearby Rentals to Hatboro-Horsham Senior High",
      "h2_subtitle": "Explore rentals near Hatboro-Horsham Senior High School. The Wellington offers comfort and convenience for students and families alike.",
      "page_copy": "Discover ideal living options at The Wellington for those seeking nearby rentals to Hatboro-Horsham Senior High School. Our community features spacious one, two, and three-bedroom apartments equipped with modern amenities like hardwood floors, cable readiness, and private balconies, providing a perfect combination of style and function.\n\nAt The Wellington, our residents enjoy a host of amenities designed to enrich their daily lives. Whether unwinding at our shimmering pool, working out in the fitness center, or spending time at the playground, there's something for everyone. Situated within Montgomery County's vibrant Horsham/Willow Grove area, we offer easy accessibility not only to Hatboro-Horsham Senior High but also to popular shopping, dining, and entertainment venues. Experience community living at its best—visit us today to discover your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Hatboro-Horsham Senior High School",
      "seo_description": "Find nearby rentals to Hatboro-Horsham High School at The Wellington. Enjoy modern amenities and a convenient location in Hatboro, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-close-to-simmons-elementary-394",
      "search_query": "apartments close to Simmons Elementary School",
      "category": "School",
      "h1_title": "Apartments Close to Simmons Elementary",
      "h2_subtitle": "Discover apartments near Simmons Elementary School. Enjoy family-friendly living at The Wellington with modern amenities in a prime location.",
      "page_copy": "The Wellington offers a superb choice for families seeking apartments close to Simmons Elementary School. Our community features a selection of spacious one, two, and three-bedroom apartments designed to cater to your family's needs, with amenities such as hardwood floors, cable readiness, and private balconies enhancing your living experience.\n\nLocated in the vibrant Hatboro area, our residents enjoy access to an array of first-rate amenities including a refreshing swimming pool, a fully equipped fitness center, and a fun-filled playground. The Wellington's location in the Horsham/Willow Grove neighborhood of Montgomery County provides families with the convenience of being near Simmons Elementary while also being close to dining options, shopping centers, and recreational spots. Schedule a tour today to see why our community is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Simmons Elementary School",
      "seo_description": "Explore apartments near Simmons Elementary School at The Wellington. Enjoy convenient, family-friendly living with modern amenities in Hatboro, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "hallowell-elementary-school-area-rentals-647",
      "search_query": "Hallowell Elementary School area rentals",
      "category": "School",
      "h1_title": "Rentals in Hallowell Elementary School Area",
      "h2_subtitle": "Find rentals in the Hallowell Elementary School area. The Wellington offers family-friendly living with modern amenities close by.",
      "page_copy": "Located conveniently near Hallowell Elementary School, The Wellington provides an excellent selection of rentals for families looking to settle in a community that balances comfort and convenience. Choose from our one, two, or three-bedroom layouts, all designed with modern touches such as hardwood floors and private balconies, perfect for school-going families.\n\nThe Wellington is not just about ideal living spaces but also features an array of community amenities that enhance residents' lifestyles. Enjoy a dip in our shimmering pool, work out in our well-equipped fitness center, or let the kids have fun at the on-site playground. Situated in the vibrant neighborhood of Horsham/Willow Grove, Montgomery County, our community offers easy access to an array of local attractions, including dining and shopping venues, ensuring that everything you need is within reach. Visit us today to discover your ideal home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hallowell Elementary School Area Rentals",
      "seo_description": "Explore rentals near Hallowell Elementary School at The Wellington. Enjoy family-friendly living with modern amenities in the Hatboro area.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "willow-dale-elementary-school-surrounding-apartments-862",
      "search_query": "Willow Dale Elementary School PA surrounding apartments",
      "category": "School",
      "h1_title": "Apartments Near Willow Dale Elementary School",
      "h2_subtitle": "Discover the benefits of living near Willow Dale Elementary School, PA. The Wellington offers modern, family-friendly apartments with great amenities.",
      "page_copy": "If you're searching for apartments near Willow Dale Elementary School in PA, The Wellington provides an unbeatable option for families. Our community offers a range of spacious one, two, and three-bedroom apartments with modern features including hardwood floors, cable readiness, and private balconies tailored to meet your lifestyle needs.\n\nLocated in the dynamic Horsham/Willow Grove area of Montgomery County, The Wellington is more than just a place to live; it’s a community that offers a wealth of amenities. Take advantage of our inviting swimming pool, engage in a workout session at the fitness center, or let your children play safely at the on-site playground. Not only are we close to Willow Dale Elementary, but we also provide easy access to local dining, shopping, and entertainment options. Visit today and discover the best in community living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Willow Dale Elementary School Nearby Apartments",
      "seo_description": "Find apartments near Willow Dale Elementary School. Enjoy family-friendly living and modern amenities at The Wellington in Hatboro, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-near-jefferson-abington-hospital-hatboro-724",
      "search_query": "apartments near Jefferson Abington Hospital Hatboro",
      "category": "Hospital",
      "h1_title": "Apartments Near Jefferson Abington Hospital",
      "h2_subtitle": "Explore convenient living near Jefferson Abington Hospital in Hatboro. The Wellington offers modern apartments with premium amenities just around the corner.",
      "page_copy": "The Wellington is the ideal choice for those seeking apartments near Jefferson Abington Hospital in Hatboro. We offer a selection of spacious one, two, and three-bedroom floor plans equipped with modern conveniences like hardwood floors, cable readiness, and private balconies, providing a comfortable living environment for healthcare professionals and families alike.\n\nNestled in the lively neighborhood of Horsham/Willow Grove in Montgomery County, The Wellington not only provides proximity to Jefferson Abington Hospital but also offers an array of first-class amenities. Enjoy relaxing at the pool, stay active in the fitness center, or let your children play on the on-site playground. Our strategic location ensures you’re never far from essential services, dining, shopping, and recreational venues. Schedule a tour today to see what makes our community the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jefferson Abington Hospital",
      "seo_description": "Find apartments near Jefferson Abington Hospital in Hatboro. Enjoy convenient living with modern amenities at The Wellington.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-near-hatboro-memorial-park-pa-378",
      "search_query": "apartments near Hatboro Memorial Park PA",
      "category": "Park",
      "h1_title": "Apartments Near Hatboro Memorial Park",
      "h2_subtitle": "Discover The Wellington, offering apartments near Hatboro Memorial Park, PA. Enjoy the convenience of modern living in a vibrant community.",
      "page_copy": "The Wellington offers a prime location for those seeking apartments near Hatboro Memorial Park in PA. Our property features a variety of spacious one, two, and three-bedroom floor plans, complete with modern amenities like hardwood flooring, balconies, and cable readiness, ensuring comfortable and stylish living.\n\nLocated in Montgomery County's Horsham/Willow Grove area, The Wellington combines proximity to Hatboro Memorial Park with the benefits of exceptional community amenities. Whether you're relaxing by the pool, working out in the fitness center, or watching your kids play in the on-site playground, you'll find plenty of ways to enjoy leisure time. Our location also places you close to local shopping, dining, and entertainment venues, making it a convenient choice for any lifestyle. Visit us and find out how you can make The Wellington your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hatboro Memorial Park",
      "seo_description": "Explore apartments near Hatboro Memorial Park at The Wellington. Enjoy modern living and easy access to community amenities in Hatboro, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-close-to-eaton-memorial-park-pa-53",
      "search_query": "apartments close to Eaton Memorial Park PA",
      "category": "Park",
      "h1_title": "Apartments Close to Eaton Memorial Park",
      "h2_subtitle": "Explore The Wellington, offering apartments close to Eaton Memorial Park, PA. Enjoy modern living with a mix of convenience and comfort.",
      "page_copy": "Situated conveniently close to Eaton Memorial Park, The Wellington in Hatboro, PA, provides the perfect home for those looking to enjoy park-side living. Our community features a selection of spacious one, two, and three-bedroom apartments, designed with modern amenities such as cable readiness, hardwood floors, and private balconies, making them ideal for relaxed, comfortable living.\n\nLocated in the vibrant Horsham/Willow Grove area, The Wellington not only offers easy access to Eaton Memorial Park but also boasts exceptional community features. Residents can unwind at the swimming pool, stay active in our fitness center, or watch their kids have fun at the on-site playground. With nearby options for dining, entertainment, and shopping, you’ll appreciate the convenience and lifestyle offerings of our neighborhood. Visit The Wellington to discover your new home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Eaton Memorial Park",
      "seo_description": "Discover apartments close to Eaton Memorial Park at The Wellington. Enjoy modern amenities and convenient living in Hatboro, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "hatboro-apartments-near-tanner-park-674",
      "search_query": "Hatboro apartments near Tanner Park",
      "category": "Park",
      "h1_title": "Hatboro Apartments Near Tanner Park",
      "h2_subtitle": "Find your ideal home at The Wellington, just minutes from Tanner Park. Experience premium comfort and convenience in Hatboro with our modern amenities.",
      "page_copy": "The Wellington in Hatboro offers the perfect choice for those seeking apartments near Tanner Park. Choose from our spacious one, two, or three-bedroom floor plans, all designed with modern amenities such as cable-ready connections, hardwood flooring, and private balconies, to provide both comfort and convenience.\n\nNestled in Montgomery County's lively Horsham/Willow Grove neighborhood, The Wellington places you right next to the natural beauty of Tanner Park while providing access to luxurious amenities like a sparkling pool, a fully equipped fitness center, and a children's playground. Whether you’re spending your day exploring Tanner Park or enjoying the vibrant local dining and shopping scenes, The Wellington ensures you have the perfect home base. Schedule a visit today to see why our community might just be the perfect fit for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hatboro Apartments Near Tanner Park",
      "seo_description": "Explore Hatboro apartments near Tanner Park at The Wellington. Enjoy modern living with amenities and conveniences nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "hatboro-pa-apartments-by-miller-meadow-89",
      "search_query": "Hatboro PA apartments by Miller Meadow",
      "category": "Park",
      "h1_title": "Hatboro Apartments by Miller Meadow",
      "h2_subtitle": "Experience quality living at The Wellington in Hatboro, PA, close to Miller Meadow. Enjoy stylish apartments and a welcoming community.",
      "page_copy": "Welcome to The Wellington, ideally located in Hatboro, PA, offering apartments by the scenic Miller Meadow. Our community provides a variety of spacious one, two, and three-bedroom layouts, each featuring modern touches like cable readiness, elegant hardwood floors, and private balconies that bring comfort and style into everyday living.\n\nSituated in the bustling Horsham/Willow Grove area, The Wellington is not only close to Miller Meadow but also offers an array of on-site amenities. Dive into relaxation at our refreshing pool, maintain your fitness routine in our well-equipped gym, or cherish family time at the playground. The nearby dining, shopping, and entertainment options enhance the convenience of our location, making The Wellington an excellent choice for your next home. Schedule a tour today and experience our vibrant community firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hatboro Apartments by Miller Meadow",
      "seo_description": "Discover Hatboro, PA apartments by Miller Meadow at The Wellington. Offering modern amenities and a prime location for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-near-pennypack-community-center-horsham-643",
      "search_query": "apartments near Pennypack Community Center Horsham",
      "category": "Park",
      "h1_title": "Apartments Near Pennypack Community Center",
      "h2_subtitle": "The Wellington offers apartments conveniently near Pennypack Community Center in Horsham. Enjoy modern living and community-focused amenities.",
      "page_copy": "Discover The Wellington, where you’ll find spacious apartments perfectly situated near the Pennypack Community Center in Horsham. Whether you're seeking a comfortable one-bedroom or need a bit more room in our two or three-bedroom layouts, each apartment is equipped with cable readiness, hardwood floors, and private balconies designed to enhance your lifestyle.\n\nLocated in the lively Horsham/Willow Grove neighborhood, The Wellington not only provides quick access to the Pennypack Community Center but also features a variety of on-site amenities that include a sparkling swimming pool, a fitness center for staying active, and a playground for family enjoyment. Experience the perfect blend of convenience and comfort as you explore the dining and entertainment options around the community. Visit us today to tour your potential new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pennypack Community Center",
      "seo_description": "Find apartments near Pennypack Community Center at The Wellington. Enjoy convenient living in Horsham with a range of modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "celano-park-nearby-hatboro-apartments-893",
      "search_query": "Celano Park nearby Hatboro apartments",
      "category": "Park",
      "h1_title": "Hatboro Apartments Near Celano Park",
      "h2_subtitle": "Explore The Wellington, offering Hatboro apartments just minutes from Celano Park. Enjoy modern amenities in a vibrant community setting.",
      "page_copy": "Welcome to The Wellington, where you can find the perfect apartment home near Celano Park in Hatboro. Our community features a selection of spacious one, two, and three-bedroom apartments, each offering modern amenities such as hardwood floors, cable readiness, and private balconies designed for relaxation and comfort.\n\nSituated in the vibrant Horsham/Willow Grove neighborhood, The Wellington not only grants easy access to the lush green spaces of Celano Park but also offers a variety of on-site facilities. Take advantage of the refreshing swimming pool, keep fit at the well-equipped gym, or enjoy outdoor activities at our playground. With plenty of local dining, shopping, and entertainment options, The Wellington is ideally located for those seeking the best of Hatboro living. Schedule a tour today to experience it all in person!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hatboro Apartments Near Celano Park",
      "seo_description": "Discover Hatboro apartments near Celano Park at The Wellington. Enjoy modern living with amenities and a great community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "warminster-community-park-adjacent-apartments-583",
      "search_query": "Warminster Community Park adjacent apartments",
      "category": "Park",
      "h1_title": "Apartments Adjacent to Warminster Park",
      "h2_subtitle": "Live at The Wellington, with apartments adjacent to Warminster Community Park. Enjoy modern amenities in a prime location.",
      "page_copy": "Discover the ideal living experience at The Wellington, where you’ll find apartments conveniently adjacent to Warminster Community Park. Our community features a variety of spacious one, two, and three-bedroom layouts, each equipped with modern amenities such as cable readiness, hardwood floors, and private balconies that enhance comfort and convenience.\n\nLocated in the bustling Horsham/Willow Grove area, The Wellington provides easy access to Warminster Community Park while offering an array of on-site attractions. Residents can enjoy a refreshing dip in the pool, work out in the state-of-the-art fitness center, or spend time with family at the playground. Nearby dining and entertainment options further enhance the lifestyle opportunities available at The Wellington. Begin your new chapter with us and schedule a visit today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Adjacent to Warminster Park",
      "seo_description": "Explore apartments adjacent to Warminster Community Park at The Wellington. Enjoy modern living with excellent amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-near-kemper-park-montgomery-county-403",
      "search_query": "apartments near Kemper Park Montgomery County",
      "category": "Park",
      "h1_title": "Apartments Near Kemper Park, Montgomery Co.",
      "h2_subtitle": "The Wellington offers well-appointed apartments near Kemper Park in Montgomery County. Enjoy spacious living and modern amenities.",
      "page_copy": "Welcome to The Wellington, where you'll find the perfect blend of comfort and accessibility with our selection of apartments near Kemper Park in Montgomery County. Choose from spacious one, two, or three-bedroom floor plans, each featuring hardwood floors, cable readiness, and private balconies that enhance your living experience.\n\nLocated in the desirable Horsham/Willow Grove neighborhood, The Wellington offers convenient access to Kemper Park, providing a serene setting amid a vibrant community. On-site amenities include a sparkling pool, a well-equipped fitness center, and a playground, ensuring you have everything you need right at your doorstep. Enjoy exploring the nearby shopping, dining, and recreational opportunities. Visit us today to discover your next home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kemper Park, Montgomery Co.",
      "seo_description": "Find spacious apartments near Kemper Park in Montgomery County at The Wellington. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-close-to-buehler-park-nature-study-390",
      "search_query": "apartments close to Buehler Park Nature Study Area Hatboro",
      "category": "Park",
      "h1_title": "Hatboro Apartments Near Buehler Park",
      "h2_subtitle": "Discover The Wellington, offering apartments close to Buehler Park Nature Study Area in Hatboro. Enjoy comfortable living with modern amenities.",
      "page_copy": "Welcome to life at The Wellington, where you can find beautiful apartments close to Buehler Park Nature Study Area in Hatboro. Our community offers spacious one, two, or three-bedroom apartments complete with modern essentials like cable readiness, hardwood flooring, and inviting balconies that provide a private escape.\n\nSituated in the vibrant Horsham/Willow Grove area of Hatboro, The Wellington seamlessly combines natural beauty with urban convenience. Residents enjoy proximity to Buehler Park's serene landscapes while benefiting from on-site features like a refreshing swimming pool, a playground, and a state-of-the-art fitness center. With easy access to local eateries, shopping, and entertainment, living at The Wellington ensures you have the best of both worlds. Schedule a tour today and make our community your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hatboro Apartments Near Buehler Park",
      "seo_description": "Explore Hatboro apartments near Buehler Park Nature Study Area at The Wellington, offering modern amenities and a community-focused lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166357",
      "source": "custom",
      "page_item_url": "apartments-near-philadelphia-international-airport-186",
      "search_query": "apartments near philadelphia international airport pa",
      "category": "Transit",
      "h1_title": "Convenient Apartments Near Philly Airport",
      "h2_subtitle": "Discover The Wellington, offering apartments conveniently near Philadelphia International Airport, PA. Enjoy premium amenities and easy access.",
      "page_copy": "Experience the perfect blend of location and lifestyle at The Wellington, featuring apartments near Philadelphia International Airport, PA. Our community provides spacious one, two, or three-bedroom units, each designed with modern conveniences like cable readiness, hardwood floors, and private balconies, ensuring a luxurious living experience.\n\nNestled in the Horsham/Willow Grove area, The Wellington offers a tranquil setting with quick access to major transportation routes leading to Philadelphia International Airport. On-site amenities include a sparkling pool, a fitness center, and playground, catering to both relaxation and recreation. With convenient access to local dining, shopping, and entertainment, The Wellington is the ideal choice for those seeking a harmonious blend of comfort and connectivity. Schedule a visit today and see what makes our community exceptional.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, including a swimming pool and surrounding trees.",
        "public_id": "01a015dc-92fc-73da-8127-036c0605a5a6",
        "storage_key": "property/6767906449166357/01a015dc-92fc-73da-8127-036c0605a5a6.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments Near Philly Airport",
      "seo_description": "Explore The Wellington's spacious, modern apartments near Philadelphia International Airport, PA. Enjoy premium amenities and excellent accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3693"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976290824"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973458"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TD9THD9N"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livethewellingtonapts.fatwin.com/api/websites/resources/1?x=SVBDUk1uTlVTUnRqeTdVeVY5dml1TmpmVmloRlBkOUxLbFh3YmxmMkxHZjU4Z28xTHErdG1kN25mQks3SDNPam9CUGh5RUFzYUFMeHRXNTlIMFpOa1E9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "18278975624"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/gow323n1p2m"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95473faa-43e6-11ef-85d6-67d7668015d2"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95473faa-43e6-11ef-85d6-67d7668015d2/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95473faa-43e6-11ef-85d6-67d7668015d2/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imozb01FWk5GQ0IzaGlaWW5WaWJNMXc9PSIsInZhbHVlIjoiVkxvZjdZZGpZQ3RKcDltMXNNTlpFZz09IiwibWFjIjoiZDk1NmFmMDkzNTYwMDc2NzE3NDA4Zjc0MjhhYWJmYjQxMmEwZWRhMmY3ZjgwZWU0OWU5ODhhMWJhMzQyMTk2YyJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "3693",
  "custom_repli_id": "9976290824",
  "custom_realpage_id": "4973458",
  "custom_google_gtm_id": "GTM-TD9THD9N",
  "custom_perq_script_url": "https://livethewellingtonapts.fatwin.com/api/websites/resources/1?x=SVBDUk1uTlVTUnRqeTdVeVY5dml1TmpmVmloRlBkOUxLbFh3YmxmMkxHZjU4Z28xTHErdG1kN25mQks3SDNPam9CUGh5RUFzYUFMeHRXNTlIMFpOa1E9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "18278975624",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/gow323n1p2m",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95473faa-43e6-11ef-85d6-67d7668015d2",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95473faa-43e6-11ef-85d6-67d7668015d2/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95473faa-43e6-11ef-85d6-67d7668015d2/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imozb01FWk5GQ0IzaGlaWW5WaWJNMXc9PSIsInZhbHVlIjoiVkxvZjdZZGpZQ3RKcDltMXNNTlpFZz09IiwibWFjIjoiZDk1NmFmMDkzNTYwMDc2NzE3NDA4Zjc0MjhhYWJmYjQxMmEwZWRhMmY3ZjgwZWU0OWU5ODhhMWJhMzQyMTk2YyJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "c657776b-b456-4c28-8f7e-dace562daeba",
  "custom_audioeye_site_hash": "716465c05f2414be351d77ec6ebf7ddd"
};

export const generatedAt = '2026-10-22T20:06:22.536Z';
